"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[21671],{

/***/ 72804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ TAGS; },
/* harmony export */   "G0": function() { return /* binding */ ATTACHMENT_TYPE; },
/* harmony export */   "TT": function() { return /* binding */ FORWARD_RECEIVER; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88187);


var TAGS = {
    symbol: "Symbol",
    account: "Account",
    symbolAndAccount: "Symbol & Account",
    none: "None"
};
var FORWARD_RECEIVER = {
    single: "Single",
    multiple: "Multiple",
    none: "None"
};
var ATTACHMENT_TYPE = {
    image: "Image",
    none: "None",
    chooseExistingPicture: "Choose Existing Picture",
    documents: "Documents",
    gif: "GIF"
};
var EVENTS = {
    chatListViewed: "Chat List Viewed",
    startChattingSelected: "Start Chatting Selected",
    chatSearchUserFilled: "Chat Search User Filled",
    newChatStarted: "New Chat Started",
    chatRoomViewed: "Chat Room Viewed",
    chatAddAttachment: "Chat Add Attachment",
    chatAttachmentSelected: "Chat Attachment Selected",
    chatSend: "Chat Send",
    chatTagSelected: "Chat Tag Selected",
    chatAddTag: "Chat Add Tag",
    chatRoomMoreSelected: "Chat Room Menu Selected",
    chatRoomCleared: "Chat Room Cleared",
    chatRoomDeleted: "Chat Room Deleted",
    chatBlockUser: "Chat Block User",
    chatBlockUserConfirmed: "Chat Block User Confirmed",
    chatUnblockUser: "Chat Unblock User",
    chatUnblockUserConfirmed: "Chat Unblock User Confirmed"
};
var GeneralEventAnalytics = {
    onChatListViewed: function() {
        var isEmpty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatListViewed, {
            "Is Empty": isEmpty
        });
    },
    onStartChatting: function() {
        var isEmpty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.startChattingSelected, {
            "Is Empty": isEmpty
        });
    },
    onChatSearchUserFilled: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatSearchUserFilled);
    },
    onNewChatStarted: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.newChatStarted);
    },
    onChatroomViewed: function(source) {
        var isMessageRequest = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, roomId = arguments.length > 2 ? arguments[2] : void 0, type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "personal";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatRoomViewed, {
            Source: source,
            "Is Message Request": isMessageRequest,
            "Message ID": roomId,
            "Chat Room Type": type.charAt(0).toUpperCase() + type.slice(1)
        });
    },
    onChatAddAttachment: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatAddAttachment);
    },
    onChatAddAttachmentSelected: function(attachment) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatAttachmentSelected, {
            Attachment: attachment
        });
    },
    onChatSend: function(attachment, tags) {
        var isForwarded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isReplied = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, forwardReceiver = arguments.length > 4 ? arguments[4] : void 0, messageId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, type = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "ROOM_TYPE_PERSONAL";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatSend, {
            Attachment: attachment,
            Tags: tags,
            "Is Forwarded": isForwarded,
            "Is Replied": isReplied,
            "Forward Receiver": forwardReceiver,
            "Message ID": messageId,
            "Chat Room Type": (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .roomTypeToRoomTypeParams */ .m)(type)
        });
    },
    onChatTagSelected: function() {
        var symbol = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isPersonalChat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, messageId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, chatRoomType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "ROOM_TYPE_PERSONAL";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatTagSelected, {
            Emiten: symbol.toUpperCase(),
            "Message ID": messageId,
            "Chat Room Type": (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .roomTypeToRoomTypeParams */ .m)(chatRoomType)
        });
    },
    onChatAddTagClicked: function() {
        var symbol = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isPersonalChat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatAddTag, {
            Emiten: symbol.toUpperCase(),
            "Chat Room Type": isPersonalChat ? "Personal" : "Group"
        });
    },
    onChatRoomMoreSelected: function(roomId) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ROOM_TYPE_PERSONAL";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatRoomMoreSelected, {
            "Room ID": roomId,
            "Chat Room Type": (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .roomTypeToRoomTypeParams */ .m)(type)
        });
    },
    onChatRoomCleared: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatRoomCleared);
    },
    onChatRoomDeleted: function() {
        var isMessageRequest = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, roomId = arguments.length > 1 ? arguments[1] : void 0, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "ROOM_TYPE_PERSONAL";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatRoomDeleted, {
            "Is Message Request": isMessageRequest,
            "Room ID": roomId,
            "Chat Room Type": (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .roomTypeToRoomTypeParams */ .m)(type)
        });
    },
    onBlockUser: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatBlockUser);
    },
    onBlockUserConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatBlockUserConfirmed);
    },
    onUnBlockUser: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatUnblockUser);
    },
    onUnBlockUserConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chatUnblockUserConfirmed);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (GeneralEventAnalytics);


/***/ }),

/***/ 88187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ roomTypeToRoomTypeParams; }
/* harmony export */ });
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42227);

function roomTypeToRoomTypeParams(roomType) {
    var types = {
        ROOM_TYPE_BROADCAST: "broadcast",
        ROOM_TYPE_GROUP: "group",
        ROOM_TYPE_PERSONAL: "personal"
    };
    var type = types[roomType];
    if (!type) {
        return undefined;
    }
    // capitalize
    return (0,utils_general__WEBPACK_IMPORTED_MODULE_0__/* .capitalizeFirstLetter */ .fm)(type);
}


/***/ }),

/***/ 52288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ GROUP_SHARED_LINK_INVITATION; },
/* harmony export */   "$6": function() { return /* binding */ DATA_WS_LOGGER; },
/* harmony export */   "Ci": function() { return /* binding */ MAX_GROUP_DESCRIPTION_LENGTH; },
/* harmony export */   "DG": function() { return /* binding */ CHAT_UNREAD_EVENT_ID; },
/* harmony export */   "E_": function() { return /* binding */ ERROR_MAX_DOCUMENT_FILE_SIZE; },
/* harmony export */   "FM": function() { return /* binding */ MAX_CHAT_UNREAD_COUNT; },
/* harmony export */   "G0": function() { return /* binding */ ATTACHMENT_TYPE; },
/* harmony export */   "H2": function() { return /* binding */ CHAT_BUBBLE_ID; },
/* harmony export */   "I": function() { return /* binding */ ALLOWED_UPLOADED_DOCUMENT_TYPES; },
/* harmony export */   "IP": function() { return /* binding */ DEFAULT_CHAT_ROOM_ID; },
/* harmony export */   "IQ": function() { return /* binding */ TOTAL_ROOM_PER_PAGE; },
/* harmony export */   "Iv": function() { return /* binding */ socketV2Key; },
/* harmony export */   "J$": function() { return /* binding */ SEND_MESSAGE_TYPE; },
/* harmony export */   "JA": function() { return /* binding */ memberRole; },
/* harmony export */   "K3": function() { return /* binding */ MAX_TOTAL_UNREAD; },
/* harmony export */   "Kn": function() { return /* binding */ StateChatList; },
/* harmony export */   "M5": function() { return /* binding */ WEBSOCKET_READYSTATE; },
/* harmony export */   "Me": function() { return /* binding */ LINK_TYPE_MESSAGE_CONTENT; },
/* harmony export */   "O": function() { return /* binding */ ALLOWED_UPLOADED_IMAGE_TYPES; },
/* harmony export */   "VY": function() { return /* binding */ SOURCE_CHAT_ROOM_VIEWED; },
/* harmony export */   "Vy": function() { return /* binding */ MAX_DOCUMENT_FILE_SIZE_MB; },
/* harmony export */   "WK": function() { return /* binding */ CHAT_RIGHT_SIDEBAR_INFO_HEADER; },
/* harmony export */   "_2": function() { return /* binding */ RoomTypeFromPayload; },
/* harmony export */   "aX": function() { return /* binding */ MAX_IMAGE_FILE_SIZE_MB; },
/* harmony export */   "aw": function() { return /* binding */ EVENT_TYPE_BROADCAST; },
/* harmony export */   "bg": function() { return /* binding */ CHAT_PUSH_NOTIFICATION_INDEX; },
/* harmony export */   "cK": function() { return /* binding */ MAX_GROUP_MEMBER_DEFAULT; },
/* harmony export */   "dn": function() { return /* binding */ MESSAGE_BODY_TYPE; },
/* harmony export */   "fO": function() { return /* binding */ WS_SOCIAL_VERSION; },
/* harmony export */   "f_": function() { return /* binding */ ERROR_MAX_IMAGE_FILE_SIZE; },
/* harmony export */   "gK": function() { return /* binding */ NOTIF_SETTING_KEY_DN; },
/* harmony export */   "gT": function() { return /* binding */ CURSOR_DIR; },
/* harmony export */   "gd": function() { return /* binding */ MAX_TIPPING_AMOUNT; },
/* harmony export */   "gx": function() { return /* binding */ LS_TOOLTIP_CREATE_GROUP_CHAT; },
/* harmony export */   "it": function() { return /* binding */ LS_TOOLTIP_REPLY_FORWARD; },
/* harmony export */   "jU": function() { return /* binding */ GROUP_CHAT_TYPE; },
/* harmony export */   "mR": function() { return /* binding */ CHAT_CONTENT_CONTAINER_ID; },
/* harmony export */   "mk": function() { return /* binding */ NOTIF_TYPE; },
/* harmony export */   "nX": function() { return /* binding */ TOOLTIP_CREATE_GROUPCHAT; },
/* harmony export */   "o6": function() { return /* binding */ MAX_AVATAR_IMAGE_SIZE; },
/* harmony export */   "of": function() { return /* binding */ DEBUG_WS_SOCIAL; },
/* harmony export */   "qz": function() { return /* binding */ WEBSOCKET_INTERVAL_PING_TIME; },
/* harmony export */   "rM": function() { return /* binding */ TOOLTIP_REPLY_FORWARD; },
/* harmony export */   "s0": function() { return /* binding */ DISPLAYED_AS; },
/* harmony export */   "ts": function() { return /* binding */ WEBSOCKET_WS_SOCIAL_PING_INTERNAL; },
/* harmony export */   "u3": function() { return /* binding */ MAX_GROUP_TITLE_LENGTH; },
/* harmony export */   "vQ": function() { return /* binding */ CHAT_RIGHT_SIDEBAR_SEARCH_HEADER; },
/* harmony export */   "wE": function() { return /* binding */ MESSAGE_WS_BODY_TYPE; },
/* harmony export */   "wS": function() { return /* binding */ NOTIF_GROUP_CHAT; },
/* harmony export */   "wq": function() { return /* binding */ CHAT_RIGHT_SIDEBAR_INFO; },
/* harmony export */   "x6": function() { return /* binding */ FORMAT_TYPE_MESSAGE_CONTENT; },
/* harmony export */   "z": function() { return /* binding */ WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION; }
/* harmony export */ });
/* unused harmony exports WEBSOCKET_TOTAL_RECONNECTION, MESSAGE_LISTENER_TAG, SOCKET_SOCIAL_REDUCERS, SOCKET_SOCIAL_ERROR, MAX_MESSAGE_PER_PAGE */
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);

var NOTIF_GROUP_CHAT = "NOTIF_GROUP_CHAT";
var NOTIF_SETTING_KEY_DN = "NOTIF_SETTING_KEY_DN";
var DATA_WS_LOGGER = {
    MODULE_NAME: "WS Social",
    LOG_LEVEL: {
        LOG: "log",
        WARN: "warn",
        ERROR: "error"
    },
    ACTION: {
        OPEN_CONNECTION: "Open Connection",
        INITIALIZE_NEW_CONNECTION: "Initialize New Connection",
        INCOMING_MESSAGE: "Incoming Message",
        ERROR_CONNECTION: "Error Connection",
        CLEAR_PING_INTERVAL: "Clear Interval Ping",
        CLOSE_PREVIOUS_CONNECTION: "Close Previous Connection",
        CLOSE_CONNECTION: "Close Connection",
        CHECK_ALLOWED_RECONNECTION: "Check Allowed Reconnection",
        SUBSCRIBE_TO_CHAT_ROOMS: "Subscribe to Chat Rooms Channel",
        UNSUBSCRIBE_TO_CHAT_ROOMS: "Unsubscribe to Chat Rooms Channel",
        SUBSCRIBE_TO_ROOM_LIST: "Subscribe to Room List Channel",
        UNSUBSCRIBE_TO_ROOM_LIST: "Unsubscribe to Room List Channel",
        DISCONNECT: "Disconnect"
    }
};
var WS_SOCIAL_VERSION = "v1";
var socketV2Key = {
    social: "social"
};
var WEBSOCKET_INTERVAL_PING_TIME = 20000; // 20s
var WEBSOCKET_TOTAL_RECONNECTION = 3;
var WEBSOCKET_WS_SOCIAL_PING_INTERNAL = "WEBSOCKET_WS_SOCIAL_PING_INTERNAL";
var DEBUG_WS_SOCIAL = "DEBUG_WS_SOCIAL";
var WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION = {
    NAME: "WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION",
    ALLOWED: false,
    NOT_ALLOWED: true
};
var MESSAGE_LISTENER_TAG = {
    OPEN_CONNECTION: "@socketSocial/openConnection"
};
var WEBSOCKET_READYSTATE = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3
};
var SEND_MESSAGE_TYPE = {
    TYPE_PING: "TYPE_PING",
    TYPE_ERROR: "TYPE_ERROR",
    TYPE_BROADCAST: "TYPE_BROADCAST",
    TYPE_SUBSCRIBE: "TYPE_SUBSCRIBE",
    TYPE_UNSUBSCRIBE: "TYPE_UNSUBSCRIBE"
};
var EVENT_TYPE_BROADCAST = {
    TYPE_CHAT_MESSAGE: "TYPE_CHAT_MESSAGE",
    TYPE_CHAT_ROOM_INFO: "TYPE_CHAT_ROOM_INFO",
    TYPE_CHAT_TYPING_INDICATOR: "TYPE_CHAT_TYPING_INDICATOR"
};
var SOCKET_SOCIAL_REDUCERS = {
    SOCKET_SOCIAL_CONNECT: "SOCKET_SOCIAL_CONNECT",
    SOCKET_SOCIAL_DISCONNECT: "SOCKET_SOCIAL_DISCONNECT",
    SOCKET_SOCIAL_STORE_SUBSCRIBED_ROOMS_ID: "SOCKET_SOCIAL_STORE_SUBSCRIBED_ROOMS_ID",
    SOCKET_SOCIAL_CLEAN_SUBSCRIBED_ROOMS_ID: "SOCKET_SOCIAL_CLEAN_SUBSCRIBED_ROOMS_ID",
    SOCKET_SOCIAL_CLEAN_ALL_SUBSCRIBED_ROOMS_ID: "SOCKET_SOCIAL_CLEAN_ALL_SUBSCRIBED_ROOMS_ID"
};
var SOCKET_SOCIAL_ERROR = {
    500: "WebSocket connection to server failed"
};
var RoomTypeFromPayload = {
    PRIVATE: "ROOM_TYPE_PRIVATE_CHAT",
    REQUESTED: "ROOM_TYPE_REQUESTED_CHAT",
    PERSONAL: "ROOM_TYPE_PERSONAL",
    GROUP: "ROOM_TYPE_GROUP",
    BROADCAST: "ROOM_TYPE_BROADCAST"
};
var memberRole = {
    MEMBER_ROLE_ADMIN: "MEMBER_ROLE_ADMIN",
    MEMBER_ROLE_NORMAL: "MEMBER_ROLE_NORMAL",
    MEMBER_ROLE_UNSPECIFIED: "MEMBER_ROLE_UNSPECIFIED"
};
var DEFAULT_CHAT_ROOM_ID = 0;
var CHAT_CONTENT_CONTAINER_ID = "chat-content-container";
var CHAT_BUBBLE_ID = "chat-bubble";
var CHAT_UNREAD_EVENT_ID = "chat-unread-event";
var MAX_AVATAR_IMAGE_SIZE = 2097152;
var MAX_GROUP_TITLE_LENGTH = 30;
var MAX_GROUP_DESCRIPTION_LENGTH = 255;
var MAX_GROUP_MEMBER_DEFAULT = 100;
var CHAT_RIGHT_SIDEBAR_INFO = "chat-right-sidebar-container";
var CHAT_RIGHT_SIDEBAR_INFO_HEADER = "chat-right-sidebar-info-header";
var CHAT_RIGHT_SIDEBAR_SEARCH_HEADER = "chat-right-sidebar-search-header";
var LINK_TYPE_MESSAGE_CONTENT = {
    LINK_TYPE_USER: "LINK_TYPE_USER",
    LINK_TYPE_SYMBOL: "LINK_TYPE_SYMBOL",
    LINK_TYPE_URL: "LINK_TYPE_URL",
    LINK_TYPE_KNOWN_URL: "LINK_TYPE_KNOWN_URL"
};
var FORMAT_TYPE_MESSAGE_CONTENT = {
    TEXT_FORMAT_REGULAR: "TEXT_FORMAT_REGULAR",
    TEXT_FORMAT_BOLD: "TEXT_FORMAT_BOLD",
    TEXT_FORMAT_ITALIC: "TEXT_FORMAT_ITALIC",
    TEXT_FOTMAT_UNDERLINE: "TEXT_FOTMAT_UNDERLINE"
};
var MAX_TIPPING_AMOUNT = 10000000;
var MAX_MESSAGE_PER_PAGE = 50;
var TOTAL_ROOM_PER_PAGE = 25;
var TOOLTIP_CREATE_GROUPCHAT = "Buat Grup Chat dan diskusi saham dengan teman-temanmu!";
var TOOLTIP_REPLY_FORWARD = "Klik untuk reply atau forward chat";
var LS_TOOLTIP_CREATE_GROUP_CHAT = "tooltipChatCreateGroup";
var LS_TOOLTIP_REPLY_FORWARD = "tooltipChatReplyForward";
var SOURCE_CHAT_ROOM_VIEWED = [
    "Chat List Page",
    "Push Notification",
    "User Profile",
    "Chat Search",
    "Inbox Chat",
    "Create New Chat",
    "Group Chat Bottom Sheet", 
];
var MAX_IMAGE_FILE_SIZE_MB = 5;
var ERROR_MAX_IMAGE_FILE_SIZE = "File is too large and cannot be uploaded. The maximum size for each file is ".concat(MAX_IMAGE_FILE_SIZE_MB, "MB");
var MAX_DOCUMENT_FILE_SIZE_MB = 10;
var ERROR_MAX_DOCUMENT_FILE_SIZE = "File you tried adding is larger than the ".concat(MAX_DOCUMENT_FILE_SIZE_MB, " MB limit.");
var MAX_CHAT_UNREAD_COUNT = 99;
var StateChatList = {
    ROOM_STATE_UNSPECIFIED: "ROOM_STATE_UNSPECIFIED",
    ROOM_STATE_ACCEPTED: "ROOM_STATE_ACCEPTED",
    ROOM_STATE_INVITED: "ROOM_STATE_INVITED"
};
var NOTIF_TYPE = [
    {
        // personal chat accepted
        type: RoomTypeFromPayload.PERSONAL,
        state: StateChatList.ROOM_STATE_ACCEPTED,
        notifType: "NOTIF_TYPE_INBOX"
    },
    {
        // personal chat requested
        type: RoomTypeFromPayload.PERSONAL,
        state: StateChatList.ROOM_STATE_INVITED,
        notifType: "NOTIF_TYPE_MESSAGE_REQUEST"
    },
    {
        type: RoomTypeFromPayload.REQUESTED,
        state: StateChatList.ROOM_STATE_INVITED,
        notifType: "NOTIF_TYPE_MESSAGE_REQUEST"
    },
    {
        // group chat accepted
        type: RoomTypeFromPayload.GROUP,
        state: StateChatList.ROOM_STATE_ACCEPTED,
        notifType: "NOTIF_TYPE_GROUPCHAT"
    },
    {
        // group chat invited
        type: RoomTypeFromPayload.GROUP,
        state: StateChatList.ROOM_STATE_INVITED,
        notifType: "NOTIF_TYPE_MESSAGE_REQUEST"
    },
    {
        // Broadcast Message
        type: RoomTypeFromPayload.BROADCAST,
        state: StateChatList.ROOM_STATE_ACCEPTED,
        notifType: "NOTIF_TYPE_INBOX"
    }, 
];
var GROUP_SHARED_LINK_INVITATION = {
    METATAG: {
        DEFAULT_NAME: "Stockbit Group Invite",
        DEFAULT_IMAGE: "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .assetPrefix */ .Vc, "/icon/stockbit-logo-black-bg-white.png")
    },
    MAX_WORDS_DESCRIPTION: 120
};
var ATTACHMENT_TYPE = {
    ATTACHMENT_TYPE_UNSPECIFIED: "ATTACHMENT_TYPE_UNSPECIFIED",
    ATTACHMENT_TYPE_GIF: "ATTACHMENT_TYPE_GIF",
    ATTACHMENT_TYPE_PHOTO: "ATTACHMENT_TYPE_PHOTO",
    ATTACHMENT_TYPE_POST: "ATTACHMENT_TYPE_POST",
    ATTACHMENT_TYPE_PDF: "ATTACHMENT_TYPE_PDF",
    ATTACHMENT_TYPE_STICKER: "ATTACHMENT_TYPE_STICKER",
    ATTACHMENT_TYPE_SHARETRADE: "ATTACHMENT_TYPE_SHARETRADE"
};
var MESSAGE_BODY_TYPE = {
    MESSAGE_BODY_TYPE_UNSPECIFIED: "MESSAGE_BODY_TYPE_UNSPECIFIED",
    MESSAGE_BODY_TYPE_CONVERSATION: "MESSAGE_BODY_TYPE_CONVERSATION",
    MESSAGE_BODY_TYPE_EVENT: "MESSAGE_BODY_TYPE_EVENT",
    // local type for separator date
    MESSAGE_BODY_TYPE_SEPARATOR_DATE: "MESSAGE_BODY_TYPE_SEPARATOR_DATE"
};
var GROUP_CHAT_TYPE = {
    // acces_type when user create group
    GROUP_TYPE_UNSPECIFIED: "GROUP_TYPE_UNSPECIFIED"
};
var CURSOR_DIR = {
    CURSOR_DIRECTION_UNSPECIFIED: "CURSOR_DIRECTION_UNSPECIFIED",
    CURSOR_DIRECTION_IN_FRONT: "CURSOR_DIRECTION_IN_FRONT",
    CURSOR_DIRECTION_BEHIND: "CURSOR_DIRECTION_BEHIND",
    CURSOR_DIRECTION_BETWEEN: "CURSOR_DIRECTION_BETWEEN"
};
var CHAT_PUSH_NOTIFICATION_INDEX = 1;
var MAX_TOTAL_UNREAD = 50;
var MESSAGE_WS_BODY_TYPE = {
    MESSAGE_BODY_TYPE_UNSPECIFIED: "MESSAGE_BODY_TYPE_UNSPECIFIED",
    MESSAGE_BODY_TYPE_CONVERSATION: "MESSAGE_BODY_TYPE_CONVERSATION",
    MESSAGE_BODY_TYPE_EVENT: "MESSAGE_BODY_TYPE_EVENT"
};
var DISPLAYED_AS = {
    DISPLAYED_AS_SENDER: "DISPLAYED_AS_SENDER",
    DISPLAYED_AS_RECEIVER: "DISPLAYED_AS_RECEIVER"
};
var ALLOWED_UPLOADED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp", 
];
var ALLOWED_UPLOADED_DOCUMENT_TYPES = [
    "application/pdf"
];


/***/ }),

/***/ 33037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ir": function() { return /* binding */ removeFormat; },
/* harmony export */   "K5": function() { return /* binding */ getNotifType; },
/* harmony export */   "Nc": function() { return /* binding */ bufferToFile; },
/* harmony export */   "OP": function() { return /* binding */ dataURItoBlob; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "XV": function() { return /* binding */ showTooltipUser; },
/* harmony export */   "f8": function() { return /* binding */ handleMaskedContentAsterisk; },
/* harmony export */   "js": function() { return /* binding */ checkTagsForAnalytics; },
/* harmony export */   "k6": function() { return /* binding */ getUploadPolicy; },
/* harmony export */   "pJ": function() { return /* binding */ readFile; },
/* harmony export */   "rP": function() { return /* binding */ chatAnalytics; },
/* harmony export */   "t_": function() { return /* binding */ snakelizeKeys; },
/* harmony export */   "td": function() { return /* binding */ formatBytes; }
/* harmony export */ });
/* unused harmony exports checkWordLinkType, getBetweenAsterisk, removeAsteriskFromCaption */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19225);
/* harmony import */ var lib_api_chat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69101);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52288);
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];








var getNotifType = function(room) {
    return _constant__WEBPACK_IMPORTED_MODULE_3__/* .NOTIF_TYPE.find */ .mk.find(function(dataNotif) {
        return dataNotif.type === room.type && dataNotif.state === room.state;
    });
};
var camelToSnakeCase = function(str) {
    return str.replace(/[A-Z]/g, function(letter) {
        return "_".concat(letter.toLowerCase());
    });
};
/**
 * snakelizeKeys
 * change keys from object to snake case
 * @param {Object} obj
 * @param {String} notAllowedObjects
 * @returns {Object}
 */ var snakelizeKeys = function(obj) {
    var notAllowedObjects = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        "maskedText"
    ];
    if (Array.isArray(obj)) {
        return obj.map(function(v) {
            return snakelizeKeys(v);
        });
    }
    if (obj != null && obj.constructor === Object) {
        return Object.keys(obj).reduce(function(result, key) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, result), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, camelToSnakeCase(key), notAllowedObjects.indexOf(key) < 0 ? snakelizeKeys(obj[key]) : obj[key]));
        }, {});
    }
    return obj;
};
var readFile = function(file) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.addEventListener("load", function() {
            return resolve(reader.result);
        }, false);
        reader.readAsDataURL(file);
    });
};
var dataURItoBlob = function(dataURI) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(dataURI.split(","), 2), mimeString = ref[0], base64 = ref[1];
    var byteString = mimeString.includes("base64") ? atob(base64) : decodeURI(base64);
    var ia = new Uint8Array(byteString.length);
    for(var i = 0; i < byteString.length; i += 1){
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([
        ia
    ], {
        type: mimeString.split(":")[1].split(";")[0]
    });
};
var copyTextToClipboard = function(text) {
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
};
var bufferToFile = function(file, type) {
    var buffer = Buffer.from(file);
    var blob = new Blob([
        buffer
    ], {
        type: type
    });
    return new File([
        blob
    ], "temp.".concat(type.split("/")[1]), {
        type: type
    });
};
var formatBytes = function(bytes, decimals) {
    if (typeof bytes === "string") return bytes;
    if (!+bytes) return "0 Bytes";
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    // eslint-disable-next-line no-restricted-properties
    return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
};
/**
 * Chat Analytics helper for divide personal and group chat
 * @param personalChatAnalytics cb - analytics personal chat callback
 * @param groupChatAnalytics cb - analytics group chat callback
 */ var chatAnalytics = function(personalChatAnalytics, groupChatAnalytics) {
    var isPersonalChat = !next_router__WEBPACK_IMPORTED_MODULE_0___default().asPath.includes("group-chat");
    if (isPersonalChat) {
        personalChatAnalytics();
    } else {
        groupChatAnalytics();
    }
};
var showTooltipUser = function(localStorageKey) {
    var ref;
    // @ts-ignore
    var username = utils_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getUserAccess */ .Z.getUserAccess().username;
    var lsData = window === null || window === void 0 ? void 0 : (ref = window.localStorage) === null || ref === void 0 ? void 0 : ref.getItem(localStorageKey);
    if (lsData && typeof JSON.parse(lsData) === "object") {
        var ref1;
        var userList = JSON.parse(window === null || window === void 0 ? void 0 : (ref1 = window.localStorage) === null || ref1 === void 0 ? void 0 : ref1.getItem(localStorageKey));
        var isAvailable = userList.includes(username);
        if (isAvailable) {
            return false;
        }
        userList.push(username);
        localStorage.setItem(localStorageKey, JSON.stringify(userList));
        return true;
    }
    var userList1 = [
        username
    ];
    localStorage.setItem(localStorageKey, JSON.stringify(userList1));
    return true;
};
var getUploadPolicy = function(params) {
    return new Promise(function(resolve, reject) {
        lib_api_chat__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getPolicy */ .ZP.getPolicy(params).then(function(res) {
            var data = res.data.data;
            resolve(data);
        }).catch(function(err) {
            reject(new Error(err));
        });
    });
};
var checkTagsForAnalytics = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var checkTagsPost = "None";
    var countSymbol = (text.match(/\$([\w-]+)/g) || []).length;
    var countMention = (text.match(/@([\w-]+)/g) || []).length;
    if (countSymbol > 0 && countMention > 0) {
        checkTagsPost = "Symbol & Account";
    } else if (countMention > 0) {
        checkTagsPost = "Account";
    } else if (countSymbol > 0) {
        checkTagsPost = "Symbol";
    }
    return checkTagsPost;
};
var REGEX_SYMBOL = /[$](?![0-9\-])([a-zA-Z0-9\-]+)/g;
var REGEX_USERNAME = /@(\w+)/g;
var REGEX_URL = /(https?:\/\/\S+)/g;
var getBetweenAsterisk = function(fullString) {
    var result = [];
    for(var i = 0; i < fullString.length; i++){
        var temporaryString = "";
        if (fullString[i] === "*") {
            for(var j = i; j < fullString.length; j++){
                if (j > 0 && fullString[j] === "*" && !fullString[j - 1].match(/\s/) && temporaryString.length == 0) {
                    break;
                }
                // handle unclosed * by /n
                // eg
                // `*helo
                // *hello*
                if (fullString[j] === "*" && temporaryString[0] === "*" && fullString[j - 1].match(/\n/)) {
                    break;
                }
                temporaryString += fullString[j];
                if (fullString[j] === "*" && fullString[j + 1] === " " || j === fullString.length - 1 && fullString[j] === "*" || fullString[j] === "*" && fullString[j + 1] === "\n") {
                    break;
                }
            }
        }
        if (temporaryString.length > 0 && temporaryString[0] === "*" && temporaryString[temporaryString.length - 1] === "*" && temporaryString.match("")) {
            if (temporaryString.match(/\*/g).length > 1) {
                // avoid word that only contains "*""
                result.push({
                    start: i,
                    end: i + temporaryString.length - 1,
                    raw: temporaryString,
                    word: temporaryString.slice(1, -1)
                });
                i += temporaryString.length - 1;
            }
        }
    }
    return result;
};
function handleMaskedContentAsterisk(content, masked_content, messageID) {
    var _loop = function(asterisk) {
        if (betweenAsterisks[asterisk].word.length === 0) {
            // handle "**"
            return "break";
        }
        var identifier = "".concat(messageID, "-").concat(asterisk);
        var renderSymbol = betweenAsterisks[asterisk].word.match(REGEX_SYMBOL) || [];
        var renderUsername = betweenAsterisks[asterisk].word.match(REGEX_USERNAME) || [];
        var renderURL = betweenAsterisks[asterisk].word.match(REGEX_URL) || [];
        var renderLinks = renderSymbol.concat(renderUsername, renderURL);
        // // render bolded links
        if (renderLinks.length > 0) {
            var _loop = function(link) {
                var rendered = false;
                keys.map(function(key) {
                    oriBetweenAsterisk.map(function(ori, idx) {
                        var oriSplit = ori.word.split(" ");
                        var temporaryStringSplit = temporaryString.split(" ");
                        var indexOfKeyInOri = oriSplit.indexOf("[%".concat(key, "%]"));
                        if (renderLinks[link] === maskedContent.masks[key].text && ori.word.includes(key)) {
                            rendered = true;
                            if (indexOfKeyInOri > -1) {
                                if (temporaryString[indexOfKeyInOri].includes("\n")) {
                                    var temporaryToReplace = temporaryString[indexOfKeyInOri];
                                    var indexofWhitespace = temporaryToReplace.lastIndexOf("\n");
                                    temporaryToReplace = temporaryToReplace.slice(0, indexofWhitespace);
                                    temporaryToReplace += "\n".repeat(indexofWhitespace + 1);
                                    temporaryToReplace += "[%".concat(key, "%]");
                                    temporaryStringSplit[indexOfKeyInOri] = temporaryToReplace;
                                } else {
                                    temporaryStringSplit[indexOfKeyInOri] = "[%".concat(key, "%]");
                                }
                                temporaryString = temporaryStringSplit.join(" ");
                                toReplaceFinal = temporaryStringSplit.join(" ");
                            } else {
                                temporaryString = temporaryString.replace("".concat(renderLinks[link]), "[%".concat(key, "%]"));
                                toReplaceFinal = temporaryString;
                            }
                            maskedContent = {
                                masks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent.masks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent.masks[key]), {
                                    format: _constant__WEBPACK_IMPORTED_MODULE_3__/* .FORMAT_TYPE_MESSAGE_CONTENT.TEXT_FORMAT_BOLD */ .x6.TEXT_FORMAT_BOLD
                                })))
                            };
                            replace = replace.replace("*".concat(toReplaceFinal, "*"), temporaryString);
                            maskedContent.text = replace;
                        }
                    });
                });
                // loading / failed state for links
                if (keys.length === 0 || !rendered) {
                    maskedContent = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent), {
                        masks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent.masks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "".concat(identifier, "-").concat(asterisk, "-").concat(link, "-link"), {
                            text: renderLinks[link],
                            format: _constant__WEBPACK_IMPORTED_MODULE_3__/* .FORMAT_TYPE_MESSAGE_CONTENT.TEXT_FORMAT_BOLD */ .x6.TEXT_FORMAT_BOLD,
                            link: {
                                ref: {
                                    symbol: renderLinks[link]
                                },
                                type: checkWordLinkType(renderLinks[link])
                            }
                        }))
                    });
                    temporaryString = temporaryString.replace(renderLinks[link], "[%".concat(identifier, "-").concat(asterisk, "-").concat(link, "-link%]"));
                    rendered = true;
                }
            };
            // render bold of basic text in between bolded sentence  that contains link
            // eg "*amazing, $BBCA is awesome*" => going to bold amazing, is awesome
            var basicTextInLink = betweenAsterisks[asterisk].word.split(/\s+/g).filter(function(word) {
                var noMatch = !word.match(REGEX_SYMBOL) && !word.match(REGEX_USERNAME);
                if (noMatch) {
                    return word;
                }
            });
            var keys = Object.keys(maskedContent.masks);
            var temporaryString = betweenAsterisks[asterisk].word;
            var toReplaceFinal = betweenAsterisks[asterisk].word;
            for(var link in renderLinks)_loop(link);
            for(var basicText in basicTextInLink){
                maskedContent = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent), {
                    masks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent.masks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "".concat(identifier, "-").concat(asterisk, "-").concat(basicText), {
                        format: _constant__WEBPACK_IMPORTED_MODULE_3__/* .FORMAT_TYPE_MESSAGE_CONTENT.TEXT_FORMAT_BOLD */ .x6.TEXT_FORMAT_BOLD,
                        text: basicTextInLink[basicText]
                    }))
                });
                temporaryString = temporaryString.replace("".concat(basicTextInLink[basicText]), "[%".concat(identifier, "-").concat(asterisk, "-").concat(basicText, "%]"));
            }
            if (typeof messageID === "string") {
                replace = replace.replace("*".concat(toReplaceFinal, "*"), temporaryString);
            } else {
                replace = replace.replace("".concat(toReplaceFinal), temporaryString);
            }
            maskedContent.text = replace;
        } else {
            maskedContent = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent), {
                masks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, maskedContent.masks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "".concat(identifier, "-").concat(asterisk), {
                    format: _constant__WEBPACK_IMPORTED_MODULE_3__/* .FORMAT_TYPE_MESSAGE_CONTENT.TEXT_FORMAT_BOLD */ .x6.TEXT_FORMAT_BOLD,
                    text: betweenAsterisks[asterisk].word
                }))
            });
            replace = replace.replace("*".concat(betweenAsterisks[asterisk].word, "*"), "[%".concat(identifier, "-").concat(asterisk, "%]"));
            maskedContent.text = replace;
        }
    };
    var betweenAsterisks = content.indexOf("*") !== -1 ? getBetweenAsterisk(content) : []; // for bold
    var maskedContent = masked_content ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, masked_content), {
        bold: true
    }) : {
        masks: {},
        text: content
    };
    var replace = maskedContent.text;
    var oriBetweenAsterisk = maskedContent.text.indexOf("*") !== -1 ? getBetweenAsterisk(maskedContent.text) : [];
    for(var asterisk in betweenAsterisks){
        var _ret = _loop(asterisk);
        if (_ret === "break") break;
    }
    return maskedContent;
}
// check if word $BBCA, @username is emitten or username
var checkWordLinkType = function(word) {
    if (word.match(REGEX_SYMBOL)) {
        return _constant__WEBPACK_IMPORTED_MODULE_3__/* .LINK_TYPE_MESSAGE_CONTENT.LINK_TYPE_SYMBOL */ .Me.LINK_TYPE_SYMBOL;
    }
    if (word.match(REGEX_USERNAME)) {
        return _constant__WEBPACK_IMPORTED_MODULE_3__/* .LINK_TYPE_MESSAGE_CONTENT.LINK_TYPE_USER */ .Me.LINK_TYPE_USER;
    }
    if (word.match(REGEX_URL)) {
        return _constant__WEBPACK_IMPORTED_MODULE_3__/* .LINK_TYPE_MESSAGE_CONTENT.LINK_TYPE_KNOWN_URL */ .Me.LINK_TYPE_KNOWN_URL;
    }
    return null;
};
var removeFormat = function(rawCaption) {
    var cleanedMD = [
        // bold
        /\*([a-zA-Z0-9\s]+)\*(?!\r?\n\*)/g,
        // underline
        /__(.*?)__/g, 
    ].reduce(function(prev, current) {
        return typeof prev === "string" ? prev.replace(current, "$1") : prev;
    }, rawCaption);
    if (typeof cleanedMD === "string") {
        return cleanedMD// replace the backslashes that contains formats
        .replace(/\\/g, "\\").replace(/\\\*/g, "*").replace(/\\_/g, "_").replace(/\\`/g, "`")// replace the html encoded
        .replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    }
    return cleanedMD;
};
// removing the asterisk that is responsible to make word bold
// usable in reply preview(bubble and compose)
// "*bold* one" -> bold one
var removeAsteriskFromCaption = function(rawCaption) {
    var resultCaption = rawCaption;
    var betweenAsterisks = getBetweenAsterisk(rawCaption);
    if (betweenAsterisks.length > 0) {
        betweenAsterisks.forEach(function(el) {
            resultCaption = resultCaption.replace(el.raw, el.word);
        });
    }
    return resultCaption;
};



/***/ }),

/***/ 16727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": function() { return /* binding */ LS_AUTH_KEY; },
/* harmony export */   "J4": function() { return /* binding */ IS_LOGGED_IN_LOCALSTORAGE; },
/* harmony export */   "JO": function() { return /* binding */ LS_REDIRECTION_TO; }
/* harmony export */ });
var LS_REDIRECTION_TO = "redirectAfterLogin";
var LS_AUTH_KEY = "at";
var IS_LOGGED_IN_LOCALSTORAGE = "isLoggedInLS";


/***/ }),

/***/ 42553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ subscribeToChatRooms; },
/* harmony export */   "q": function() { return /* binding */ unSubscribeToChatRooms; }
/* harmony export */ });
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24050);


/**
 * subscribeToChatRooms
 * @param {Array} chatroomIds
 * @returns
 */ function subscribeToChatRooms() {
    var chatroomIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function() {
        if (chatroomIds.length > 0) {
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .wsLogger */ .IT)({
                module: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.MODULE_NAME */ .$6.MODULE_NAME,
                action: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.ACTION.SUBSCRIBE_TO_CHAT_ROOMS */ .$6.ACTION.SUBSCRIBE_TO_CHAT_ROOMS,
                payload: chatroomIds
            });
            var payload = {
                type: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .SEND_MESSAGE_TYPE.TYPE_SUBSCRIBE */ .J$.TYPE_SUBSCRIBE,
                payload: {
                    channel: {
                        chatroom: chatroomIds
                    }
                }
            };
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .sendMessageWsSocial */ .U0)(payload);
        }
    };
}
/**
 * unSubscribeToChatRooms
 * @param {Array} chatroomIds
 * @returns
 */ function unSubscribeToChatRooms() {
    var chatroomIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function() {
        if (chatroomIds.length > 0) {
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .wsLogger */ .IT)({
                module: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.MODULE_NAME */ .$6.MODULE_NAME,
                action: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.ACTION.UNSUBSCRIBE_TO_CHAT_ROOMS */ .$6.ACTION.UNSUBSCRIBE_TO_CHAT_ROOMS,
                payload: chatroomIds
            });
            var payload = {
                type: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .SEND_MESSAGE_TYPE.TYPE_UNSUBSCRIBE */ .J$.TYPE_UNSUBSCRIBE,
                payload: {
                    channel: {
                        chatroom: chatroomIds
                    }
                }
            };
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .sendMessageWsSocial */ .U0)(payload);
        }
    };
}


/***/ }),

/***/ 34686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ subscribeToRoomList; },
/* harmony export */   "M": function() { return /* binding */ unSubscribeToRoomList; }
/* harmony export */ });
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24050);


/**
 * subscribeToChatRooms
 */ function subscribeToRoomList() {
    return function() {
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .wsLogger */ .IT)({
            module: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.MODULE_NAME */ .$6.MODULE_NAME,
            action: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.ACTION.SUBSCRIBE_TO_ROOM_LIST */ .$6.ACTION.SUBSCRIBE_TO_ROOM_LIST
        });
        var payload = {
            type: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .SEND_MESSAGE_TYPE.TYPE_SUBSCRIBE */ .J$.TYPE_SUBSCRIBE,
            payload: {
                channel: {
                    roomlist: true
                }
            }
        };
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .sendMessageWsSocial */ .U0)(payload);
    };
}
/**
 * subscribeToChatRooms
 */ function unSubscribeToRoomList() {
    return function() {
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .wsLogger */ .IT)({
            module: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.MODULE_NAME */ .$6.MODULE_NAME,
            action: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.ACTION.UNSUBSCRIBE_TO_ROOM_LIST */ .$6.ACTION.UNSUBSCRIBE_TO_ROOM_LIST
        });
        var payload = {
            type: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .SEND_MESSAGE_TYPE.TYPE_UNSUBSCRIBE */ .J$.TYPE_UNSUBSCRIBE,
            payload: {
                channel: {
                    roomlist: true
                }
            }
        };
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .sendMessageWsSocial */ .U0)(payload);
    };
}


/***/ }),

/***/ 36784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ getSocketV2; },
/* harmony export */   "JC": function() { return /* binding */ initWebsocketSocialV2; }
/* harmony export */ });
/* unused harmony exports setSocketV2, initWebsocketV2 */
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24050);


var DATAFEED_SOCKET = (/* unused pure expression or super */ null && ("wss://wss-trading.stockbit.com/ws"));
var SOCIAL_SOCKET = "wss://wssocial.stockbit.com";
var socketV2Manager = {
    social: null
};
/**
 * Store websocket instance to socket manager, also change binaryType to arraybuffer
 * @param {string} key Key of websocket in socket manager
 * @param {WebSocket} socket Instance of the websocket
 * @returns {WebSocket} WebSocket instance
 */ var setSocketV2 = function(key, socket) {
    socketV2Manager[key] = socket;
    socketV2Manager[key].binaryType = "arraybuffer";
    return socketV2Manager[key];
};
/**
 * Get websocket instance from socket manager, will return undefined if not available
 * @param {string} key Key of websocket in socket manager
 * @returns {WebSocket | undefined} WebSocket instance
 */ var getSocketV2 = function(key) {
    return socketV2Manager[key];
};
var initWebsocketV2 = function() {
    if (false) {}
    // @ts-ignore
    if (window.websocketV2) {
        // @ts-ignore
        window.websocketV2.dispatchEvent(new Event("socketv2_reconnected"));
        // @ts-ignore
        return window.websocketV2;
    }
    var websocketV2 = new WebSocket(DATAFEED_SOCKET);
    websocketV2.binaryType = "arraybuffer";
    // @ts-ignore
    window.websocketV2 = websocketV2;
    return websocketV2;
};
var composeWSSocialUrl = function(wskey) {
    var url = new URL(SOCIAL_SOCKET);
    var search = new URLSearchParams({
        wskey: wskey
    });
    url.search = decodeURIComponent(search.toString());
    return url.toString();
};
var initWebsocketSocialV2 = function(socketKey, wsKey) {
    if (false) {}
    var wsUrl = composeWSSocialUrl(wsKey);
    // close previous websocketSocialV2 connection
    // should ready to close prev ws connection
    if (window.websocketSocialV2 && window.websocketSocialV2.readyState === features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .WEBSOCKET_READYSTATE.OPEN */ .M5.OPEN) {
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .wsLogger */ .IT)({
            module: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.MODULE_NAME */ .$6.MODULE_NAME,
            action: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.ACTION.CLOSE_PREVIOUS_CONNECTION */ .$6.ACTION.CLOSE_PREVIOUS_CONNECTION,
            logLevel: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.LOG_LEVEL.WARN */ .$6.LOG_LEVEL.WARN
        });
        window.websocketSocialV2.close();
    }
    (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .wsLogger */ .IT)({
        module: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.MODULE_NAME */ .$6.MODULE_NAME,
        action: features_chat_constant__WEBPACK_IMPORTED_MODULE_0__/* .DATA_WS_LOGGER.ACTION.INITIALIZE_NEW_CONNECTION */ .$6.ACTION.INITIALIZE_NEW_CONNECTION,
        payload: wsKey
    });
    var websocketSocialV2 = setSocketV2(socketKey, new WebSocket(wsUrl));
    // @ts-ignore
    window.websocketSocialV2 = websocketSocialV2;
    return websocketSocialV2;
};



/***/ }),

/***/ 66250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WM": function() { return /* binding */ chatWsSocialV2Selector; },
  "Z": function() { return /* binding */ clearIntervalPingWSSocial; },
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "fh": function() { return /* binding */ getWskey; }
});

// UNUSED EXPORTS: actions, selectors

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/message/v1/send_pb.js
var send_pb = __webpack_require__(79278);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/message/v1/received_pb.js + 17 modules
var received_pb = __webpack_require__(45621);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/utils/socketSocialLocalStorage.ts
var socketSocialLocalStorage = __webpack_require__(42676);
;// CONCATENATED MODULE: ./src/global/WebSocketV2/Utils/queuingProcess.ts


var queue = [];
var DELAY_INCOMING_MESSAGE_TIME = 1000;
function getFromQueue() {
    return queue.shift();
}
var insertQueue = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(msg) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return queue.push(msg);
                case 2:
                    return _ctx.abrupt("return", new Promise(function(res) {
                        return setTimeout(function() {
                            var data = getFromQueue();
                            res(data);
                        }, DELAY_INCOMING_MESSAGE_TIME);
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function insertQueue(msg) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/global/WebSocketV2/utils.ts
var utils = __webpack_require__(24050);
// EXTERNAL MODULE: ./src/global/WebSocketV2/channels/roomList.ts
var roomList = __webpack_require__(34686);
// EXTERNAL MODULE: ./src/global/WebSocketV2/channels/chatRoom.ts
var chatRoom = __webpack_require__(42553);
;// CONCATENATED MODULE: ./src/global/WebSocketV2/slice.ts
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];
/* eslint-disable no-plusplus */ /* eslint-disable no-console */ 













var initialState = {
    websocketV2: {
        validated: false,
        error: null
    },
    websocketSocialV2: {
        data: {}
    }
};
var wsSelector = function(state) {
    return state.websocketV2;
};
// selectors
var selectors = (0,es/* createSelector */.P1)(wsSelector, function(ws) {
    return (0,_object_spread/* default */.Z)({}, ws);
});
// Ws Social V2
var chatWsSocialV2Selector = (0,es/* createSelector */.P1)(function(state) {
    return state.websocketV2.websocketSocialV2.data;
}, function(state) {
    return state;
});
// Actions
var CONTEXT = "@redux/webSocketV2";
var actionType = {
    INIT_WEBSOCKETSOCIALV2: "".concat(CONTEXT, "/INIT_WEBSOCKETSOCIALV2"),
    INCOMING_MESSAGE_WEBSOCKETSOCIALV2: (0,redux_toolkit_esm/* createAction */.PH)("".concat(CONTEXT, "/INCOMING_MESSAGE_WEBSOCKETSOCIALV2")),
    RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2: "".concat(CONTEXT, "/RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2"),
    DO_RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2: (0,redux_toolkit_esm/* createAction */.PH)("".concat(CONTEXT, "/DO_RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2"))
};
var actions = (/* unused pure expression or super */ null && (actionType));
// API actions
var getWskey = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, message, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get wskey failed");
                case 6:
                    _data = response.data, error = _data.error, message = _data.message, data = _data.data;
                    if (!error) {
                        _ctx.next = 9;
                        break;
                    }
                    // @ts-ignore
                    throw new Error({
                        error: error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", data.key);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    return _ctx.abrupt("return", null);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function getWskey() {
        return _ref.apply(this, arguments);
    };
}();
var pingDispatcher = function(webSocketSocialV2) {
    return function() {
        var readyState = webSocketSocialV2.readyState;
        if (!webSocketSocialV2) {
            ;
            return;
        }
        var payload = send_pb/* SendMessage.fromJson */.uz.fromJson({
            type: constant/* SEND_MESSAGE_TYPE.TYPE_PING */.J$.TYPE_PING
        }).toBinary();
        if ((0,utils/* isConnectionOpen */.Lv)(readyState)) {
            webSocketSocialV2.send(payload);
        }
    };
};
var pingWSSocial = function(dispatch, webSocketSocialV2) {
    var idInterval = setInterval(function() {
        return dispatch(pingDispatcher(webSocketSocialV2));
    }, constant/* WEBSOCKET_INTERVAL_PING_TIME */.qz);
    // store ping id interval to localStorage
    (0,socketSocialLocalStorage/* saveIdIntervalPingWsSocial */.QW)(idInterval);
};
var clearIntervalPingWSSocial = function() {
    var idInterval = (0,socketSocialLocalStorage/* getIdIntervalPingWsSocial */.r8)();
    if (idInterval) {
        (0,utils/* wsLogger */.IT)({
            module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
            action: constant/* DATA_WS_LOGGER.ACTION.CLEAR_PING_INTERVAL */.$6.ACTION.CLEAR_PING_INTERVAL,
            payload: idInterval
        });
        // clear interval ping ws social
        clearInterval(parseInt(idInterval));
        // remove ping id interval in localStorage
        (0,socketSocialLocalStorage/* removeIdIntervalPingWsSocial */.rv)();
    }
};
var effects = {
    initWebsocketSocialV2: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.INIT_WEBSOCKETSOCIALV2, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var webSocketSocialV2, createSocialSocket, dispatch, getState, wsSocialV2, ref, _entities, _credentials, isUserLogin, parsedCookie, token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        webSocketSocialV2 = param.webSocketSocialV2, createSocialSocket = param.createSocialSocket, dispatch = param1.dispatch, getState = param1.getState;
                        if (webSocketSocialV2) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        wsSocialV2 = webSocketSocialV2;
                        ref = getState(), _entities = ref.// @ts-ignore
                        entities, _credentials = _entities.credentials, isUserLogin = _credentials.isLoggedIn;
                        parsedCookie = auth/* default.getToken */.Z.getToken();
                        token = parsedCookie.accessToken.token;
                        if (!(!isUserLogin || !token)) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 9:
                        if (token) {
                            wsSocialV2.onopen = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var ref, ref1, ref2, activeRoomId;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            (0,utils/* wsLogger */.IT)({
                                                module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
                                                action: constant/* DATA_WS_LOGGER.ACTION.OPEN_CONNECTION */.$6.ACTION.OPEN_CONNECTION
                                            });
                                            // to keep websocket connection keep alive
                                            pingWSSocial(dispatch, webSocketSocialV2);
                                            activeRoomId = Number((ref = getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.entities) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chat) === null || ref2 === void 0 ? void 0 : ref2.activeRoomId);
                                            // subscribe to current active chat room
                                            if (activeRoomId > 0) {
                                                dispatch((0,chatRoom/* subscribeToChatRooms */.F)([
                                                    activeRoomId
                                                ]));
                                            }
                                            // subscribe to room list channel
                                            dispatch((0,roomList/* subscribeToRoomList */.I)());
                                            // initial state, allowed reconnection
                                            (0,socketSocialLocalStorage/* storeErrorNoReconnectionWsSocial */.x1)(constant/* WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION.ALLOWED */.z.ALLOWED);
                                        case 7:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            wsSocialV2.onmessage = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                                    var data, buffer, payload;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                data = param.data;
                                                buffer = Buffer.from(data, "base64");
                                                payload = received_pb/* ReceivedMessage.fromBinary */.gn.fromBinary(buffer).toJson();
                                                if (!(payload.type === constant/* SEND_MESSAGE_TYPE.TYPE_BROADCAST */.J$.TYPE_BROADCAST)) {
                                                    _ctx.next = 8;
                                                    break;
                                                }
                                                _ctx.next = 6;
                                                return insertQueue(payload).then(function(data) {
                                                    (0,utils/* wsLogger */.IT)({
                                                        module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
                                                        action: constant/* DATA_WS_LOGGER.ACTION.INCOMING_MESSAGE */.$6.ACTION.INCOMING_MESSAGE,
                                                        payload: data
                                                    });
                                                    dispatch(// @ts-ignore
                                                    actionType.INCOMING_MESSAGE_WEBSOCKETSOCIALV2({
                                                        data: data
                                                    }));
                                                });
                                            case 6:
                                                _ctx.next = 9;
                                                break;
                                            case 8:
                                                {
                                                    dispatch(// @ts-ignore
                                                    actionType.INCOMING_MESSAGE_WEBSOCKETSOCIALV2({
                                                        data: payload
                                                    }));
                                                }
                                            case 9:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            wsSocialV2.onerror = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(err) {
                                    var isAllowedReconnection;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                (0,utils/* wsLogger */.IT)({
                                                    module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
                                                    action: constant/* DATA_WS_LOGGER.ACTION.ERROR_CONNECTION */.$6.ACTION.ERROR_CONNECTION,
                                                    logLevel: constant/* DATA_WS_LOGGER.LOG_LEVEL.ERROR */.$6.LOG_LEVEL.ERROR,
                                                    payload: err
                                                });
                                                wsSocialV2.close();
                                                dispatch(// @ts-ignore
                                                actionType.DO_RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2());
                                                isAllowedReconnection = !JSON.parse((0,socketSocialLocalStorage/* getErrorNoReconnectionWsSocial */.vW)());
                                                if (isAllowedReconnection) {
                                                    // set to NOT allowed reconnection
                                                    (0,socketSocialLocalStorage/* storeErrorNoReconnectionWsSocial */.x1)(constant/* WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION.NOT_ALLOWED */.z.NOT_ALLOWED);
                                                }
                                            case 5:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(err) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            wsSocialV2.onclose = function() {
                                (0,utils/* wsLogger */.IT)({
                                    module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
                                    action: constant/* DATA_WS_LOGGER.ACTION.CLOSE_CONNECTION */.$6.ACTION.CLOSE_CONNECTION,
                                    logLevel: constant/* DATA_WS_LOGGER.LOG_LEVEL.WARN */.$6.LOG_LEVEL.WARN
                                });
                                // reconnection
                                var isAllowedReconnection = !JSON.parse((0,socketSocialLocalStorage/* getErrorNoReconnectionWsSocial */.vW)());
                                (0,utils/* wsLogger */.IT)({
                                    module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
                                    action: constant/* DATA_WS_LOGGER.ACTION.CHECK_ALLOWED_RECONNECTION */.$6.ACTION.CHECK_ALLOWED_RECONNECTION,
                                    logLevel: constant/* DATA_WS_LOGGER.LOG_LEVEL.WARN */.$6.LOG_LEVEL.WARN,
                                    payload: isAllowedReconnection
                                });
                                // clear inverval ping WS Social
                                clearIntervalPingWSSocial();
                                dispatch(// @ts-ignore
                                actionType.DO_RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2());
                                if (isAllowedReconnection) {
                                    // reconnection
                                    createSocialSocket();
                                }
                                wsSocialV2.removeEventListener("message", null);
                            };
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    resetWebsocketSocialV2: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2, function(_, param) {
        var dispatch = param.dispatch;
        dispatch(// @ts-ignore
        actionType.DO_RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2());
    })
};
var reducers = {
    clearChat: function(state) {
        state.websocketSocialV2.data = {};
    }
};
var extraReducers = function(builder) {
    builder.addCase(actionType.INCOMING_MESSAGE_WEBSOCKETSOCIALV2, function(state, action) {
        var data = action.payload.data;
        var sendMessageType = data === null || data === void 0 ? void 0 : data.type;
        // only type broadcast
        if (sendMessageType === constant/* SEND_MESSAGE_TYPE.TYPE_BROADCAST */.J$.TYPE_BROADCAST) {
            state.websocketSocialV2.data = data;
        }
    }).addCase(actionType.DO_RESET_INCOMING_MESSAGE_WEBSOCKETSOCIALV2, function(state) {
        state.websocketSocialV2.data = {};
    });
};
var webSocketSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "websocketV2",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (webSocketSlice);


/***/ }),

/***/ 24050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": function() { return /* binding */ wsLogger; },
/* harmony export */   "Lv": function() { return /* binding */ isConnectionOpen; },
/* harmony export */   "U0": function() { return /* binding */ sendMessageWsSocial; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _stockbitgroup_protos_social_wssocial_entity_message_v1_send_pb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79278);
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52288);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36784);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86123);





/**
 * isConnectionOpen
 * @param {Number} readyState
 * @returns {Boolean}
 */ var isConnectionOpen = function(readyState) {
    return readyState === features_chat_constant__WEBPACK_IMPORTED_MODULE_2__/* .WEBSOCKET_READYSTATE.OPEN */ .M5.OPEN;
};
/**
 * sendMessageWsSocial
 * @param {object} payload
 * @param {object} webSocketSocialV2
 * @returns
 */ var sendMessageWsSocial = function(payload) {
    var webSocketSocialV2 = (0,___WEBPACK_IMPORTED_MODULE_3__/* .getSocketV2 */ .E4)(features_chat_constant__WEBPACK_IMPORTED_MODULE_2__/* .socketV2Key.social */ .Iv.social);
    if (!webSocketSocialV2) {
        return;
    }
    var sendDataBinary = _stockbitgroup_protos_social_wssocial_entity_message_v1_send_pb__WEBPACK_IMPORTED_MODULE_1__/* .SendMessage.fromJson */ .uz.fromJson(payload).toBinary();
    // send message
    if (isConnectionOpen(webSocketSocialV2.readyState)) {
        webSocketSocialV2.send(sendDataBinary);
    }
};
var wsLogger = function(param) {
    var _module = param.module, module = _module === void 0 ? "" : _module, _action = param.action, action = _action === void 0 ? "" : _action, _logLevel = param.logLevel, logLevel = _logLevel === void 0 ? "log" : _logLevel, _payload = param.payload, payload = _payload === void 0 ? undefined : _payload;
    // Only allow on ui.lab
    if (!constants_app__WEBPACK_IMPORTED_MODULE_4__/* .PROJECT_FOLDER_PATH */ .qV) {
        return;
    }
    var date = moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date()).format("YYYY-MM-DD");
    var time = moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date(), "HH:mm").format("HH:mm");
    ;
    if (payload) console[logLevel](payload);
    ;
};


/***/ }),

/***/ 39762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZA": function() { return /* binding */ emailLogin; },
  "YT": function() { return /* binding */ fbLogin; },
  "u9": function() { return /* binding */ googleLogin; },
  "kS": function() { return /* binding */ logout; },
  "qD": function() { return /* binding */ verifyOTP; }
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestNext.ts






var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestNext() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var apiInstance = axios_default().create({
        baseURL: "/".concat(app/* PROJECT_FOLDER */.sP || ""),
        headers: {
            accept: "application/json"
        }
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref;
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token;
        if (token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", response);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function(error) {
        if (!(error === null || error === void 0 ? void 0 : error.response) || !isShowAlertMessage) {
            return Promise.reject(error);
        }
        var _response = error.response, status = _response.status, data = _response.data;
        var message = data === null || data === void 0 ? void 0 : data.message;
        var errorType = data === null || data === void 0 ? void 0 : data.error_type;
        // the real error message is unparsed in `message`
        if (!errorType) {
            var parsedMessage = JSON.parse(message);
            message = parsedMessage.message;
            errorType = parsedMessage.error_type;
        }
        APIExodusErrorHandler(status, errorType, message);
        return Promise.reject(error);
    });
    return apiInstance;
}
/* harmony default export */ var config_requestNext = (requestNext);

;// CONCATENATED MODULE: ./src/lib/api/authNext.ts


var request = config_requestNext();
var emailLogin = function(param) {
    var username = param.username, password = param.password, verificationToken = param.verificationToken, recaptchaVersion = param.recaptchaVersion;
    if (app/* PROJECT_FOLDER */.sP) {
        return request.get("/api/login/email", {
            params: {
                username: username,
                password: password,
                verificationToken: verificationToken,
                recaptchaVersion: recaptchaVersion
            }
        });
    }
    return request.post("/api/login/email", {
        username: username,
        password: password,
        verificationToken: verificationToken,
        recaptchaVersion: recaptchaVersion
    });
};
var fbLogin = function(param) {
    var id = param.id, key = param.key;
    if (app/* PROJECT_FOLDER */.sP) {
        return request.get("/api/login/facebook", {
            params: {
                id: id,
                key: key
            }
        });
    }
    return request.post("/api/login/facebook", {
        id: id,
        key: key
    });
};
var googleLogin = function(param) {
    var id = param.id, key = param.key;
    if (app/* PROJECT_FOLDER */.sP) {
        return request.get("/api/login/google", {
            params: {
                id: id,
                key: key
            }
        });
    }
    return request.post("/api/login/google", {
        id: id,
        key: key
    });
};
var verifyOTP = function(param) {
    var key = param.key, otp = param.otp;
    if (app/* PROJECT_FOLDER */.sP) {
        if (key) {
            return request.get("/api/register/verify-otp", {
                params: {
                    key: key,
                    otp: otp
                }
            });
        }
        return request.get("/api/register/verify-otp", {
            params: {
                otp: otp
            }
        });
    }
    return request.post("/api/register/verify-otp", {
        key: key,
        otp: otp
    });
};
var logout = function() {
    if (app/* PROJECT_FOLDER */.sP) {
        return request.get("/api/logout");
    }
    return request.post("/api/logout");
};


/***/ }),

/***/ 69101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ leaveGroupAndChangeAdmin; },
/* harmony export */   "Ad": function() { return /* binding */ getSuggested; },
/* harmony export */   "Kn": function() { return /* binding */ findRoom; },
/* harmony export */   "Ln": function() { return /* binding */ leaveGroup; },
/* harmony export */   "Lq": function() { return /* binding */ inviteMember; },
/* harmony export */   "sS": function() { return /* binding */ createGroup; },
/* harmony export */   "sX": function() { return /* binding */ getSearchGroupUser; },
/* harmony export */   "x5": function() { return /* binding */ getMemberList; }
/* harmony export */ });
/* unused harmony exports getRooms, getRequestedRooms, getRoomMessage, readChat, acceptRequest, rejectRequest, respondInvitation, setAdminStatus */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6430);
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 






var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var requestWithoutAlert = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false);
var CHAT_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/chat");
var YOUTUBE_OEMBED_URL = "https://www.youtube.com/oembed?format=json&url=";
/**
 * Get Room List
 * @param { Object } params
 * @param {string|number=} params.limit
 * @param {string|number=} params.offset
 * @param {string=} params.keyword
 * @returns {APIResponse}
 */ var getRooms = function(params, sourceToken) {
    return request.get("".concat(CHAT_URL, "/v2/rooms"), {
        params: params,
        cancelToken: sourceToken === null || sourceToken === void 0 ? void 0 : sourceToken.token
    });
};
/**
 * Get Requested Room List
 * @param { Object } params
 * @param {string|number=} params.limit
 * @param {string=} params.offset
 * @param {string=} params.keyword
 * @returns {APIResponse}
 */ var getRequestedRooms = function(params) {
    return request.get("".concat(CHAT_URL, "/v2/rooms/type/invited"), {
        params: params
    });
};
/**
 * Send Chat Message
 * @param {Object} params
 * @param {string} params.content
 * @param {string=} params.attachment_url
 * @param {string|number=} params.to_user_id
 * @returns {APIResponse}
 */ var sendChat = function(params) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        to_user_id: 0,
        attachment_url: ""
    }, params);
    return request.post("".concat(CHAT_URL, "/messages"), data);
};
/**
 * Send Bulk Share Chat Message
 * @param {Object} params
 * @param {Array} params.receivers
 * @param {string} params.text
 * @param {Object} params.shared_content
 * @param {number} params.shared_content.id
 * @param {string} params.shared_content.type
 * @param {string} params.attachment_url
 * @returns {APIResponse}
 */ var sendBulkChat = function(params) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        text: ""
    }, params);
    return request.post("".concat(CHAT_URL, "/v2/messages/bulk"), data);
};
/**
 * Clear chat
 * @param {string | number} roomId
 * @returns {APIResponse}
 */ var clearChat = function(roomId) {
    return request.post("".concat(CHAT_URL, "/rooms/").concat(roomId, "/clear"));
};
/**
 * Get all messages per chat
 * @param {string|number} roomId - Room ID
 * @param {Object=} params - Additional paramenters
 * @returns {APIResponse}
 */ var getRoomMessage = function(roomId, params) {
    return request.get("".concat(CHAT_URL, "/rooms/").concat(roomId, "/messages"), {
        params: params
    });
};
/**
 * Delete Room
 * @param {string | number} roomId
 * @returns {APIResponse}
 */ var deleteChatRoom = function(roomId) {
    return request.delete("".concat(CHAT_URL, "/rooms/").concat(roomId));
};
/**
 * Mark chat as read
 * @param {string|number} roomId - Room ID
 * @returns {APIResponse}
 */ var readChat = function(roomId) {
    return request.post("".concat(CHAT_URL, "/rooms/").concat(roomId, "/read"));
};
/**
 * Get room
 * @param {string|number} roomId
 * @returns {APIResponse}
 */ var getRoom = function(roomId) {
    return request.get("".concat(CHAT_URL, "/v2/rooms/").concat(roomId));
};
/**
 * Accept Requested Chat
 * @param {string|number} roomId - Room ID
 * @returns {APIResponse}
 */ var acceptRequest = function(roomId) {
    return request.post("".concat(CHAT_URL, "/rooms/").concat(roomId, "/accept"));
};
/**
 * Reject Requested Chat
 * @param {string|number} roomId - Room ID
 * @returns {APIResponse}
 */ var rejectRequest = function(roomId) {
    return request.post("".concat(CHAT_URL, "/rooms/").concat(roomId, "/reject"));
};
var getYoutubeDetail = function(youtubeUrl) {
    return fetch("".concat(YOUTUBE_OEMBED_URL).concat(youtubeUrl));
};
/**
 * Get policy
 * @param {string|number} roomId
 * @returns {APIResponse}
 */ var getPolicy = function(params) {
    return request.get("".concat(CHAT_URL, "/s3/policy"), {
        params: params
    });
};
/**
 * Forward Chat Message
 * @param {Object} params
 * @param {string} params.text
 * @param {string=} params.message_ids
 * @param {string|number=} params.receivers
 * @returns {APIResponse}
 */ var forwardChat = function(params) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        text: ""
    }, params);
    return request.post("".concat(CHAT_URL, "/v2/messages/forward"), data);
};
/**
 * Get Suggested User
 * @param { Object } params
 * @param {string|number=} params.limit
 * @param {string|number=} params.offset
 * @param {number} params.for_group_id
 * @returns {APIResponse}
 */ var getSuggested = function(params) {
    return request.get("".concat(CHAT_URL, "/v2/groups/members/suggestions"), {
        params: params
    });
};
/**
 * Search Group User
 * @param { Object } params
 * @param {string} params.cursor
 * @param {string} params.keyword
 * @param {string|number=} params.per_page
 * @param {string|number=} params.by_group_id
 * @returns {APIResponse}
 */ var getSearchGroupUser = function(params) {
    return request.get("".concat(CHAT_URL, "/v2/groups/members/search"), {
        params: params
    });
};
/**
 * Get group messages
 * @param {string|number} roomId - Room ID
 * @returns {APIResponse}
 */ var getGroupRoom = function(roomId) {
    return request.get("".concat(CHAT_URL, "/v2/groups/room-id/").concat(roomId));
};
/**
 * Get group messages without alert
 * @param {string|number} roomId - Room ID
 * @returns {APIResponse}
 */ var getGroupRoomSilent = function(roomId) {
    return requestWithoutAlert.get("".concat(CHAT_URL, "/v2/groups/room-id/").concat(roomId));
};
/**
 * Get personal messages
 * @param {string|number} roomId - Room ID
 * @param {Object=} params - Additional paramenters
 * @param {number=} params.limit
 * @param {string=} params.cursor_dir
 * @param {number=} params.cursor_id
 * @param {bool} params.show_stream
 * @returns {APIResponse}
 */ var getPersonalMessage = function(roomId, params) {
    return request.get("".concat(CHAT_URL, "/v2/personal/").concat(roomId, "/messages"), {
        params: params
    });
};
/**
 * Get broadcast messages
 * @param {string|number} roomId - Room ID
 * @param {Object=} params - Additional paramenters
 * @param {number=} params.limit
 * @param {string=} params.cursor_dir
 * @param {number=} params.cursor_id
 * @param {bool} params.show_stream
 * @returns {APIResponse}
 */ var getBroadcastMessage = function(roomId, params) {
    return request.get("".concat(CHAT_URL, "/v2/broadcast/").concat(roomId, "/messages"), {
        params: params
    });
};
/**
 * Get group messages
 * @param {string|number} roomId - Group ID
 * @param {Object=} params - Additional paramenters
 * @param {string|number=} params.limit
 * @param {string|number=} params.offset
 * @returns {APIResponse}
 */ var getGroupMessage = function(groupId, params) {
    return request.get("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/messages"), {
        params: params
    });
};
/**
 * Mute Group Notification
 * @param {string|number} roomId - Group ID
 * @param {bool} muted - Is Muted
 * @returns {APIResponse}
 */ var muteNotification = function(groupId, isMuted) {
    return request.post("".concat(CHAT_URL, "/v2/rooms/").concat(groupId, "/mute"), {
        is_muted: isMuted
    });
};
/**
 * Send Chat Message V2
 */ var sendChatV2 = function(params) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        text: "",
        attachment_url: ""
    }, params);
    return request.post("".concat(CHAT_URL, "/v2/messages"), data).catch(function(err) {
        var ref;
        // ERROR_MESSAGE.FORBIDDEN is ignored at global handler src/config/APIErrorMessage/handler.js
        // Need to handle forbidden error from spesific API call
        if (((ref = err.cause) === null || ref === void 0 ? void 0 : ref.errorType) === constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].FORBIDDEN */ .Z.FORBIDDEN) {
            var ref1;
            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                content: (ref1 = err.cause) === null || ref1 === void 0 ? void 0 : ref1.message,
                messageType: "error",
                alertType: "snackbar",
                hasCloseIcon: true
            });
        }
        throw err;
    });
};
/**
 * Search Receivers
 * @param {string} keyword
 */ var getSearchReceivers = function(keyword) {
    return request.get("".concat(CHAT_URL, "/v2/receivers/shareable-search"), {
        params: {
            keyword: keyword
        }
    });
};
/**
 *  Get Memberlist
 * @param {string} keyword
 * @param {number} limit
 * @param {number} offset
 * @param {string} status
 * @param {boolean} selfExcluded
 */ var getMemberList = function(groupId, keyword, limit, offset, status, selfExcluded) {
    return request.get("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/members"), {
        params: {
            keyword: keyword,
            limit: limit,
            offset: offset,
            status: status,
            self_exclude: selfExcluded
        }
    });
};
/**
 * Update Group Detail
 * @param groupId
 * @param { Object } data
 * @param {string} params.avatar
 * @param {string} params.description
 * @param {string} params.name
 * @returns
 */ var updateChatGroup = function(groupId, data) {
    return request.put("".concat(CHAT_URL, "/v2/groups/").concat(groupId), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data));
};
/**
 * Reset Group Chat Link Invitation
 * @param groupId
 * @returns
 */ var resetLink = function(groupId) {
    return request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/reset-link"));
};
/**
 *  Invite Member
 */ var inviteMember = function(groupId, userIds) {
    return request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/members/invite"), {
        user_ids: userIds
    });
};
/**
 * Create Group
 *
 * @param {Object} data
 * @param {string} data.name
 * @param {string} data.description
 * @param {string} data.avatar_url
 * @param {Array} data.user_ids
 */ var createGroup = function(data) {
    return request.post("".concat(CHAT_URL, "/v2/groups"), data);
};
/**
 * Find room
 * @param {string|number} userId
 * @returns {APIResponse}
 */ var findRoom = function(userId) {
    return requestWithoutAlert.get("".concat(CHAT_URL, "/rooms/userid/").concat(userId));
};
/**
 * Respond Invited Chat
 * @param {string|number} roomId - Room ID
 * @param {string} action - Action Payload
 * @returns {APIResponse}
 */ var respondInvitation = function(roomId, action) {
    return request.post("".concat(CHAT_URL, "/v2/invitations/room-id/").concat(roomId, "/respond"), {
        action: action
    });
};
/**
 * Assign/Remove Admin
 * @param {string|number} groupId - Group ID
 * @param {Object}        data
 * @param {string|number} data.user_id - User ID
 * @param {boolean}       data.status - Status
 * @returns {APIResponse}
 */ var setAdminStatus = function(groupId, data) {
    return request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/set-admin-status"), data);
};
/**
 * Leave Group
 * @param {string|number} groupId - Group ID
 * @param {Object}        data
 * @param {boolean} data.must_delete - Must Delete
 * @returns {APIResponse}
 */ var leaveGroup = function(groupId, data) {
    return request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/members/leave"), data);
};
/**
 * Leave Group and Change Admin
 * @param {string|number} groupId - Group ID
 * @param {Object}        data
 * @param {number[]}       data.user_id - User Id
 * @returns {APIResponse}
 */ var leaveGroupAndChangeAdmin = function(groupId, data) {
    return request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/change-admin-and-leave"), data);
};
/**
 * Search Receivers
 * @param {string} keyword
 * @param {string} cursor
 * @param {number} limit
 * @param {number} groupId
 */ var getSearchContactDiscovery = function(keyword, cursor, limit, groupId) {
    return request.get("".concat(CHAT_URL, "/v2/groups/members/suggestions/contacts"), {
        params: {
            keyword: keyword,
            limit: limit,
            cursor: cursor,
            for_group_id: groupId
        }
    });
};
/**
 * Get Max Member In Group
 * @returns {APIResponse}
 */ var getMaxMemberInGroup = function() {
    return requestWithoutAlert.get("".concat(CHAT_URL, "/v2/groups/members/max"));
};
/**
 * Get LoggedIn Group Invitation Preview
 * @param {string} code
 * @returns {APIResponse}
 */ var getGroupInvitationPreview = function(code) {
    return request.get("".concat(CHAT_URL, "/v2/invitations/preview/").concat(code));
};
/**
 * Get Guest Group Invitation Preview
 * @param {string} code
 * @returns {APIResponse}
 */ var getGroupInvitationGuestPreview = function(code) {
    return requestWithoutAlert.get("".concat(CHAT_URL, "/v2/invitations/public-preview/").concat(code));
};
/**
 * Join Group
 * @param {string} code
 * @returns {APIResponse}
 */ var postJoinGroup = function(code) {
    return request.post("".concat(CHAT_URL, "/v2/invitations/join/").concat(code));
};
/**
 * Delete Bulk Chat Message
 * @param {number=} message_ids
 * @returns {APIResponse}
 */ var deleteBulkChatMessage = function(messageIds) {
    return request.post("".concat(CHAT_URL, "/v2/messages/bulk-delete"), {
        message_ids: messageIds
    });
};
/**
 * Invitation Bulk Response
 * @param {string} action
 * @param {Array} room_ids
 * @returns {APIResponse}
 */ var invitationBulkRespond = function(data) {
    return request.post("".concat(CHAT_URL, "/v2/invitations/bulk-respond"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data));
};
/**
 * Delete All Invitations
 * @returns {APIResponse}
 */ var deleteAllInvitations = function() {
    return request.delete("".concat(CHAT_URL, "/v2/invitations"));
};
/**
 * Remove Group Member
 * @param {string|number} groupId - Group ID
 * @param {Object}        data
 * @param {string|number} data.user_id - User ID
 * @returns {APIResponse}
 */ var removeGroupMember = function(groupId, data) {
    return request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/members/remove"), data);
};
// Share Trade
var postGroupShareTradeSetting = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(groupId, requestBody) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", request.post("".concat(CHAT_URL, "/v2/groups/").concat(groupId, "/settings"), requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postGroupShareTradeSetting(groupId, requestBody) {
        return _ref.apply(this, arguments);
    };
}();
var getUnreadCount = function() {
    return request.get("".concat(CHAT_URL, "/v2/rooms/unread/count"));
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getYoutubeDetail: getYoutubeDetail,
    sendChat: sendChat,
    getRooms: getRooms,
    getRoomMessage: getRoomMessage,
    sendBulkChat: sendBulkChat,
    deleteChatRoom: deleteChatRoom,
    getRoom: getRoom,
    readChat: readChat,
    clearChat: clearChat,
    getRequestedRooms: getRequestedRooms,
    acceptRequest: acceptRequest,
    rejectRequest: rejectRequest,
    getPolicy: getPolicy,
    forwardChat: forwardChat,
    getSuggested: getSuggested,
    getSearchGroupUser: getSearchGroupUser,
    getGroupRoom: getGroupRoom,
    getGroupMessage: getGroupMessage,
    muteNotification: muteNotification,
    sendChatV2: sendChatV2,
    getSearchReceivers: getSearchReceivers,
    getMemberList: getMemberList,
    updateChatGroup: updateChatGroup,
    resetLink: resetLink,
    respondInvitation: respondInvitation,
    getPersonalMessage: getPersonalMessage,
    getBroadcastMessage: getBroadcastMessage,
    setAdminStatus: setAdminStatus,
    getSearchContactDiscovery: getSearchContactDiscovery,
    getMaxMemberInGroup: getMaxMemberInGroup,
    getGroupInvitationPreview: getGroupInvitationPreview,
    getGroupInvitationGuestPreview: getGroupInvitationGuestPreview,
    postJoinGroup: postJoinGroup,
    deleteBulkChatMessage: deleteBulkChatMessage,
    invitationBulkRespond: invitationBulkRespond,
    deleteAllInvitations: deleteAllInvitations,
    removeGroupMember: removeGroupMember,
    getGroupRoomSilent: getGroupRoomSilent,
    postGroupShareTradeSetting: postGroupShareTradeSetting,
    getUnreadCount: getUnreadCount
});


/***/ }),

/***/ 1955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/** @typedef {import('axios').AxiosResponse} AxiosResponse */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 



var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
// Configs
var USER_URL = "/user";
var USER_PROFILE_URL = "".concat(USER_URL, "/profile");
var USER_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/user");
// onboarding
var USER_ONBOARDING = "".concat(USER_URL, "/onboarding");
var USER_CONNECT_SOCIAL_MEDIA = "".concat(USER_URL, "/v2/connect");
var USER_DISCONNECT_SOCIAL_MEDIA = "".concat(USER_URL, "/disconnect");
// avatar
var USER_AVATAR3D_LIST_URL = "".concat(USER_URL, "/avatar/collection");
// Block
/**
 * Block user by User id.
 * @param {string} userId - string of user id
 * @returns {APIResponse}
 */ var blockUser = function(userId) {
    return requestExodus.post("".concat(USER_EXODUS_URL, "/").concat(userId, "/block"));
};
/**
 * Block user by User id.
 * @param {string} userId - string of user id
 * @returns {APIResponse}
 */ var unblockUser = function(userId) {
    return requestExodus.post("".concat(USER_EXODUS_URL, "/").concat(userId, "/unblock"));
};
/**
 * Get list of blocked users
 * @param {number} page - target page
 * @returns {APIResponse}
 */ var getBlockedUser = function() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return requestExodusNoAlert.get("".concat(USER_EXODUS_URL, "/blocked"), {
        params: {
            page: page
        }
    });
};
// User Profile
/**
 * Edit user profile.
 * @param {string} userId - string of user id
 * @param {string} website - string of website url
 * @param {string} gender - string of user gender
 * @param {string} about - string of user descriptions
 * @param {string} avatar - string of avatar url
 * @param {string} fullname - string of user's fullname
 * @param {string} email  - string of user's email
 * @param {string} exchange - string of user's exchange
 */ var editUserProfile = function(_param) {
    var website = _param.website, gender = _param.gender, about = _param.about, avatar = _param.avatar, fullname = _param.fullname, email = _param.email, exchange = _param.exchange, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "website",
        "gender",
        "about",
        "avatar",
        "fullname",
        "email",
        "exchange"
    ]);
    return requestExodusNoAlert.put("".concat(USER_EXODUS_URL, "/profile"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        website: website,
        gender: gender,
        about: about,
        avatar: avatar,
        fullname: fullname,
        email: email,
        exchange: exchange
    }, params));
};
/**
 * Get list of trending user by range of time
 * @param {string} timeRange - range of time indicator ['1W']
 * @returns {APIResponse}
 */ var getTrendingUser = function() {
    var timeRange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1W";
    return requestExodusNoAlert.get("".concat(USER_EXODUS_URL, "/trending"), {
        params: {
            key: timeRange
        }
    });
};
/**
 * Get user profile by username
 * @param {string} username - exact username of user
 * @return {AxiosResponse}
 */ var getUserProfile = function(username) {
    return requestExodusNoAlert.get("".concat(USER_PROFILE_URL, "/").concat(username));
};
/**
 * Get user profile graph by username
 * @param {string} username - exact username of user
 * @return {AxiosResponse}
 */ var getUserProfileGraph = function(username) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/usergraph/socialinfo/").concat(username));
};
var getGuestUserProfileGraph = function(username) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/usergraph/non-login/socialinfo/").concat(username));
};
/**
 * Get current user profile graph
 * @return {AxiosResponse}
 */ var getCurrentUserProfileGraph = function() {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/usergraph/socialinfo/user/me"));
};
/**
 * Get user profile by username
 * @param {string} username - exact username of user
 * @return {AxiosResponse}
 */ var getUserProfileExodus = function(username) {
    return requestExodusNoAlert.get("".concat(USER_EXODUS_URL, "/profile/").concat(username));
};
/**
 * retrieveUploadToken
 * to skip onboarding process
 */ var retrieveUploadToken = function(fileName) {
    return requestExodus.post("".concat(USER_URL, "/upload/token"), {
        filename: fileName
    });
};
/**
 * userSkipOnboarding
 * to skip onboarding process
 * @param {number} step - next step onboarding
 */ var userSkipOnboarding = function(step) {
    return requestExodus.post("".concat(USER_ONBOARDING), {
        step: step
    });
};
/**
 * userConnectSocialMedia
 * to connect user to social media account
 * @param {string} socialMediaName - social media's name
 * @param {object} requestBody - spcial media's object needed
 */ var userConnectSocialMedia = function(socialMediaName, requestBody) {
    return requestExodus.post("".concat(USER_CONNECT_SOCIAL_MEDIA, "/").concat(socialMediaName), requestBody);
};
/**
 * Disconnect social media from user account
 * @param {string} socialMediaName
 * @return {APIResponse}
 */ var disconnectSocialMedia = function(socialMediaName, requestBody) {
    return requestExodus.post("".concat(USER_DISCONNECT_SOCIAL_MEDIA, "/").concat(socialMediaName), requestBody);
};
/**
 * Mute user
 * @param {Object} suspendData - The data sent when suspend user
 * @param {number} suspendData.userid - User ID
 * @param {number} suspendData.postid - User ID
 * @param {number} suspendData.blockmode - Type of suspension
 * @param {string} suspendData.reason - Mute reason
 * @param {string} suspendData.duration - Mute duration
 * @param {boolean} suspendData.sendEmail - Send notification of being mute to user
 * @param {boolean} suspendData.blockIp - Block IP permanently from system
 *
 * @return {AxiosResponse}
 */ var suspendUser = function(param) {
    var userid = param.userid, postid = param.postid, blockmode = param.blockmode, reason = param.reason, duration = param.duration, sendEmail = param.sendEmail, blockIp = param.blockIp;
    var data = {
        type: blockmode,
        user_id: userid,
        reason: reason,
        days: duration,
        stream_id: postid,
        send_email: sendEmail,
        block_ip: blockIp
    };
    return requestExodus.post("".concat(USER_URL, "/admin/suspend"), data);
};
/**
 * Get Avatar3D List
 * @returns {AxiosResponse}
 */ var getAvatar3DList = function() {
    return requestExodusNoAlert.get("".concat(USER_AVATAR3D_LIST_URL));
};
var updatePreference = function(data) {
    return requestExodus.put("".concat(USER_EXODUS_URL, "/profile/country"), data);
};
// Exports ---------------------------------------------------------------------
/* harmony default export */ __webpack_exports__["Z"] = ({
    blockUser: blockUser,
    unblockUser: unblockUser,
    getBlockedUser: getBlockedUser,
    editUserProfile: editUserProfile,
    getTrendingUser: getTrendingUser,
    getUserProfile: getUserProfile,
    getUserProfileExodus: getUserProfileExodus,
    getUserProfileGraph: getUserProfileGraph,
    getGuestUserProfileGraph: getGuestUserProfileGraph,
    getCurrentUserProfileGraph: getCurrentUserProfileGraph,
    retrieveUploadToken: retrieveUploadToken,
    userSkipOnboarding: userSkipOnboarding,
    userConnectSocialMedia: userConnectSocialMedia,
    disconnectSocialMedia: disconnectSocialMedia,
    suspendUser: suspendUser,
    getAvatar3DList: getAvatar3DList,
    updatePreference: updatePreference
});


/***/ }),

/***/ 15056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78372);
/* eslint-disable no-undef */ /* eslint-disable camelcase */ /* eslint-disable import/named */ 



var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].noAlert */ .Z.noAlert;
// Exodus API
var WATCHLIST_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/watchlist");
var COMPANY_EXODUS_WATCHLIST = "".concat(WATCHLIST_EXODUS_URL, "/company");
var COMPANY_EXODUS_WATCHLIST_SUGGESTION = "".concat(WATCHLIST_EXODUS_URL, "/suggestion/company");
var PEOPLE_EXODUS_WATCHLIST = "".concat(WATCHLIST_EXODUS_URL, "/people");
var postFollowUser = function(userid) {
    return requestExodus.post("".concat(PEOPLE_EXODUS_WATCHLIST, "/item"), {
        user_id: userid
    });
};
var postUnfollowUser = function(userid) {
    return requestExodus.delete("".concat(PEOPLE_EXODUS_WATCHLIST, "/").concat(userid, "/item"));
};
/**
 * Set notification alert for certain user
 * @param {number} userid
 * @returns {APIResponse}
 */ var setNotificationAlert = function(userid) {
    return requestExodus.put("".concat(PEOPLE_EXODUS_WATCHLIST, "/alert"), {
        user_id: userid
    });
};
var getPeopleFollowers = function(userid, params) {
    return requestExodusNoAlert.get("".concat(PEOPLE_EXODUS_WATCHLIST, "/").concat(userid, "/followers"), {
        params: params
    });
};
// company watchlist
var getAllWatchlist = function(companyid, withTotal) {
    var page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 500;
    // eslint-disable-next-line no-undef
    var params = {
        page: page,
        limit: limit
    };
    if (companyid) {
        params.company_id = companyid;
    }
    if (withTotal) {
        params.with_total = withTotal;
    }
    return requestExodusNoAlert.get("".concat(WATCHLIST_EXODUS_URL), {
        params: params
    });
};
var getDetailWatchlist = function(watchlistid) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var bodyParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        page: 1,
        limit: 500,
        nochart: 1
    }, params);
    return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false).get("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid), {
        params: bodyParams
    });
};
var getSymbolWatchlist = function(watchlistId) {
    return requestExodusNoAlert.get("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistId, "/symbols"));
};
var getCompanyFollowers = function(companyid, params) {
    return requestExodusNoAlert.get("".concat(COMPANY_EXODUS_WATCHLIST, "/").concat(companyid, "/followers"), {
        params: params
    });
};
var getCompanySuggestions = function(watchlistid) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return requestExodusNoAlert.get(COMPANY_EXODUS_WATCHLIST_SUGGESTION, {
        params: {
            watchlist_id: watchlistid,
            limit: limit
        }
    });
};
var postFollowCompany = function(watchlistid, companyid) {
    return requestExodus.post("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid, "/company/item"), {
        company_id: Number(companyid)
    });
};
var postUnfollowCompany = function(watchlistid, companyid) {
    return requestExodus.delete("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid, "/company/").concat(companyid, "/item"));
};
// core watchlist
var createNewWatchlist = function(name, description) {
    return requestExodus.post("".concat(WATCHLIST_EXODUS_URL), {
        name: name,
        description: description
    });
};
var deleteWatchlistById = function(watchlistid) {
    return requestExodus.delete("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid));
};
var updateWatchlist = function(watchlistid, name, description) {
    return requestExodus.put("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid), {
        name: name,
        description: description
    });
};
// financial metrics
var addFinancialMetrics = function(watchlistid, fitemid) {
    var req = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false);
    return req.post("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid, "/column"), {
        fitemid: Number(fitemid)
    });
};
var removeFinancialMetrics = function(watchlistid, fitemid) {
    return requestExodus.delete("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid, "/column/").concat(fitemid));
};
var getFinancialValues = function(watchlistid, fitemid) {
    return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false).get("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid, "/column"), {
        params: {
            fitemid: fitemid
        }
    });
};
var reorderFinancialValues = function(watchlistid, fitemid) {
    return requestExodus.put("".concat(WATCHLIST_EXODUS_URL, "/").concat(watchlistid, "/column/reorder"), {
        fitemid: fitemid
    });
};
var getPeopleFollowing = function(userid, params) {
    return requestExodusNoAlert.get("".concat(PEOPLE_EXODUS_WATCHLIST, "/").concat(userid, "/following"), {
        params: params
    });
};
var getCompanyFollowerInfo = function(symbol) {
    return requestExodusNoAlert.get("".concat(COMPANY_EXODUS_WATCHLIST, "/follower-info"), {
        params: {
            symbols: symbol
        }
    });
};
// Exports ---------------------------------------------------------------------
/* harmony default export */ __webpack_exports__["Z"] = ({
    // people watchlist
    postUnfollowUser: postUnfollowUser,
    postFollowUser: postFollowUser,
    setNotificationAlert: setNotificationAlert,
    getPeopleFollowers: getPeopleFollowers,
    getPeopleFollowing: getPeopleFollowing,
    // company watchlist
    postFollowCompany: postFollowCompany,
    postUnfollowCompany: postUnfollowCompany,
    getCompanyFollowers: getCompanyFollowers,
    getCompanySuggestions: getCompanySuggestions,
    getCompanyFollowerInfo: getCompanyFollowerInfo,
    // new watchlist fetch
    getAllWatchlist: getAllWatchlist,
    getDetailWatchlist: getDetailWatchlist,
    getSymbolWatchlist: getSymbolWatchlist,
    // core watchlist
    createNewWatchlist: createNewWatchlist,
    deleteWatchlistById: deleteWatchlistById,
    updateWatchlist: updateWatchlist,
    // financial metrics
    addFinancialMetrics: addFinancialMetrics,
    removeFinancialMetrics: removeFinancialMetrics,
    getFinancialValues: getFinancialValues,
    reorderFinancialValues: reorderFinancialValues
});


/***/ }),

/***/ 10707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61876);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25516);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var lib_entities_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16992);
/* harmony import */ var lib_api_chat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69101);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6430);
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52288);
/* harmony import */ var _utils_chat__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21779);
/* eslint-disable no-undef */ /* eslint-disable eqeqeq */ /* eslint-disable import/no-named-as-default-member */ /* eslint-disable camelcase */ 












/**
 * Note on conversation schema:
 * Conversation schema will be filled with actual response from API arranged by its chat id
 * thus it will looks like:
 * conversation: {
 *  [chatId]: {
 *    data: Array<Record<string, any>>,
 *    more: boolean,
 *  }
 * }
 */ var initialState = {
    activeRoomId: features_chat_constant__WEBPACK_IMPORTED_MODULE_6__/* .DEFAULT_CHAT_ROOM_ID */ .IP,
    conversation: {},
    lastMessage: {},
    error: null,
    isLoading: false,
    isLoadingRooms: false,
    isLoadMessage: false,
    isLoadMoreRooms: false,
    isLoadPrevMessage: false,
    isLoadAcceptRequest: false,
    isLoadRejectRequest: false,
    message: "",
    rooms: [],
    room: {
        group: {},
        personal: {}
    },
    requests: [],
    requestCount: 0,
    unreadRequest: 0,
    reply: {
        visible: false,
        to_id: 0
    },
    select: {
        visible: false,
        messageIds: [],
        selectedAlign: []
    },
    receivers: {
        list: []
    },
    invitation: {
        isLoadingAccept: false,
        isLoadingReject: false
    }
};
// Selectors
var chatSelector = function(state) {
    return state.entities.chat;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(chatSelector, function(chat) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, chat);
});
// Actions
var CONTEXT = "@redux/chat";
var actionType = {
    SET_ACTIVE_ROOM_ID: "".concat(CONTEXT, "/SET_ACTIVE_ROOM_ID"),
    RESET_ACTIVE_ROOM_ID: "".concat(CONTEXT, "/RESET_ACTIVE_ROOM_ID"),
    GET_ROOMS: "".concat(CONTEXT, "/GET_ROOMS"),
    SEND_CHAT: "".concat(CONTEXT, "/SEND_CHAT"),
    SEND_BULK_CHAT: "".concat(CONTEXT, "/SEND_BULK_CHAT"),
    DELETE_CHAT_ROOM: "".concat(CONTEXT, "/DELETE_CHAT_ROOM"),
    READ_CHAT: "".concat(CONTEXT, "/READ_CHAT"),
    GET_REQUESTED_ROOMS: "".concat(CONTEXT, "/GET_REQUESTED_ROOMS"),
    ACCEPT_REQUESTED_ROOM: "".concat(CONTEXT, "/ACCEPT_REQUESTED_ROOM"),
    REJECT_REQUESTED_ROOM: "".concat(CONTEXT, "/REJECT_REQUESTED_ROOM"),
    GET_POLICY: "".concat(CONTEXT, "/GET_POLICY"),
    FORWARD_CHAT: "".concat(CONTEXT, "/FORWARD_MESSAGE"),
    SHARE_EVENT_TO_CHAT: "".concat(CONTEXT, "/SHARE_TO_CHAT"),
    GET_SEARCH_RECEIVERS: "".concat(CONTEXT, "/GET_SEARCH_RECEIVERS"),
    MUTE_GROUP_NOTIFICATION: "".concat(CONTEXT, "/MUTE_GROUP_NOTIFICATION"),
    RESPOND_GROUP_INVITATION: "".concat(CONTEXT, "/RESPOND_GROUP_INVITATION")
};
// Side effects
var effects = {
    setActiveRoomId: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.SET_ACTIVE_ROOM_ID, function(params) {
        try {
            return {
                data: params
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }),
    resetActiveRoomId: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.RESET_ACTIVE_ROOM_ID, function() {
        try {
            return {
                data: initialState.activeRoomId
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }),
    getRooms: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.GET_ROOMS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getRooms */ .ZP.getRooms(param);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get room list");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            offset: param.offset
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(param) {
            return _ref.apply(this, arguments);
        };
    }()),
    sendChat: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.SEND_CHAT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sendChat */ .ZP.sendChat(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send chat failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    sendBulkChat: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.SEND_BULK_CHAT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sendBulkChat */ .ZP.sendBulkChat(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send chat failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST_SHARED_SUCCESSFUL */ .Z.POST_SHARED_SUCCESSFUL, constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SNACKBAR_GREEN */ .Z.SNACKBAR_GREEN, true);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteChatRoom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.DELETE_CHAT_ROOM, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(roomId) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].deleteChatRoom */ .ZP.deleteChatRoom(roomId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete chat failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            roomId: roomId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(roomId) {
            return _ref.apply(this, arguments);
        };
    }()),
    readChat: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.READ_CHAT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(roomId) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].readChat */ .ZP.readChat(roomId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to read chat failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            roomId: roomId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(roomId) {
            return _ref.apply(this, arguments);
        };
    }()),
    getRequestedRooms: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.GET_REQUESTED_ROOMS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getRequestedRooms */ .ZP.getRequestedRooms(param);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get room list");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            offset: param.offset
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(param) {
            return _ref.apply(this, arguments);
        };
    }()),
    acceptRequestedRoom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.ACCEPT_REQUESTED_ROOM, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(roomId) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].acceptRequest */ .ZP.acceptRequest(roomId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to accept room");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            roomId: roomId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(roomId) {
            return _ref.apply(this, arguments);
        };
    }()),
    rejectRequestedRoom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.REJECT_REQUESTED_ROOM, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(roomId) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].rejectRequest */ .ZP.rejectRequest(roomId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to reject room");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            roomId: roomId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(roomId) {
            return _ref.apply(this, arguments);
        };
    }()),
    getPolicy: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.GET_POLICY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getPolicy */ .ZP.getPolicy(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get policy");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    forwardChat: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.FORWARD_CHAT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].forwardChat */ .ZP.forwardChat(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send chat failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    shareEventToChat: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.SHARE_EVENT_TO_CHAT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sendBulkChat */ .ZP.sendBulkChat(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send chat failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].EVENT_SHARED_SUCCESSFUL */ .Z.EVENT_SHARED_SUCCESSFUL, constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SNACKBAR_GREEN */ .Z.SNACKBAR_GREEN, true);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    muteNotification: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.MUTE_GROUP_NOTIFICATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var roomId, isMuted, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        roomId = param.roomId, isMuted = param.isMuted;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].muteNotification */ .ZP.muteNotification(roomId, isMuted);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to mute notification failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            roomId: roomId
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getSearchReceivers: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_RECEIVERS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getSearchReceivers */ .ZP.getSearchReceivers(param.keyword);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get search receivers");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(param) {
            return _ref.apply(this, arguments);
        };
    }()),
    respondGroupInvitation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)(actionType.RESPOND_GROUP_INVITATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var roomId, action, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        roomId = param.roomId, action = param.action;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* ["default"].respondInvitation */ .ZP.respondInvitation(roomId, action);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to accept room");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            roomId: roomId
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    // update current active chat
    updateChat: function(state, action) {
        var _payload = action.payload, chatId = _payload.chatId, chat = _payload.chat;
        if (state.conversation[chatId]) {
            var dataConvo = state.conversation[chatId];
            var isOnConvo = dataConvo.data.some(function(message) {
                return message.id === chatId;
            });
            if (!isOnConvo) {
                var ref, ref1;
                (ref = state.conversation[chatId]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.unshift(chat);
            }
        } else {
            state.conversation[chatId] = {
                data: [
                    chat
                ]
            };
        }
    },
    // Update Room List
    updateRoomList: function(state, action) {
        var newChat = action.payload;
        var isPrivateChat = newChat.state === "ROOM_STATE_ACCEPTED";
        // decide where to place updated chat/room
        // rooms is for private, and requests is for request chat
        var stateBucket = isPrivateChat ? "rooms" : "requests";
        var newChatList = state[stateBucket];
        var roomIdx = newChatList.findIndex(function(room) {
            return room.id === newChat.id;
        });
        var isRoomAvail = roomIdx > -1;
        if (isRoomAvail) {
            newChatList.splice(roomIdx, 1);
        }
        newChatList.unshift(newChat);
        state[stateBucket] = newChatList;
        if (!isPrivateChat && !isRoomAvail) {
            state.requestCount += 1;
        }
        if (!isPrivateChat) {
            if (isRoomAvail && state.requests[roomIdx].unread_count === 0) {
                state.unreadRequest += 1;
            } else if (!isRoomAvail) {
                state.unreadRequest += 1;
            }
        }
    },
    replyTo: function(state, action) {
        var replyToData = action.payload;
        state.reply = replyToData;
    },
    selectMessageItem: function(state, action) {
        var _payload = action.payload, messageId = _payload.messageId, chatId = _payload.chatId, checked = _payload.checked, align = _payload.align;
        if (state.select.messageIds.length > 9 && checked) {
            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                content: "You can select up to 10 messages",
                messageType: "error",
                alertType: "snackbar",
                hasCloseIcon: true
            });
        } else {
            var chatIndex = state.conversation[chatId].data.findIndex(function(convo) {
                return convo.id === messageId;
            });
            state.conversation[chatId].data[chatIndex].select = checked;
            if (checked) {
                state.select.messageIds.push(messageId);
                state.select.selectedAlign.push(align);
            } else {
                var index = state.select.messageIds.indexOf(messageId);
                if (index > -1) {
                    state.select.messageIds.splice(index, 1); // 2nd parameter means remove one item only
                    state.select.selectedAlign.splice(index, 1);
                }
            }
        }
    },
    cancelSelect: function(state, action) {
        var chatId = action.payload.chatId;
        state.select.messageIds = [];
        var convoUpdated = state.conversation[chatId].data.map(function(convo) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, convo), {
                select: false
            });
        });
        state.conversation[chatId].data = convoUpdated;
    },
    toggleForwardModal: function(state, action) {
        var visible = action.payload;
        state.select.visible = visible;
    },
    resetReceiverList: function(state) {
        state.receivers.list = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.setActiveRoomId.fulfilled, function(state, action) {
        var data = action.payload.data;
        state.activeRoomId = Number(data);
    }).addCase(effects.resetActiveRoomId.fulfilled, function(state, action) {
        var data = action.payload.data;
        state.activeRoomId = Number(data);
    }).addCase(effects.getRooms.pending, function(state, action) {
        state.error = null;
        var _arg = action.meta.arg, _offset = _arg.offset, offset = _offset === void 0 ? 0 : _offset, _hasLoading = _arg.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
        if (offset === 0) {
            if (hasLoading) {
                state.rooms = [];
                state.isLoadingRooms = true;
            }
        } else {
            state.isLoadMoreRooms = true;
        }
    }).addCase(effects.getRooms.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message, offset = _payload.offset;
        var _arg = action.meta.arg, _hasLoading = _arg.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
        if (error) {
            state.error = error;
        } else {
            if (hasLoading) {
                // uniq by id
                var concatRooms = (0,_utils_chat__WEBPACK_IMPORTED_MODULE_12__/* .uniq */ .j)(state.rooms.concat(data.rooms), // eslint-disable-next-line no-shadow
                function(data) {
                    return data.id;
                });
                state.rooms = concatRooms;
            } else {
                state.rooms = data.rooms;
            }
            state.requestCount = data.total_invited;
            state.unreadRequest = data === null || data === void 0 ? void 0 : data.unread_request;
            state.error = null;
        }
        if (offset === 0) {
            state.isLoadingRooms = false;
        } else {
            state.isLoadMoreRooms = false;
        }
        state.message = message;
    }).addCase(effects.sendBulkChat.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.deleteChatRoom.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            var roomId = data.room_id;
            // remove all data related to `roomId`
            var roomIdx = state.rooms.findIndex(function(room) {
                return room.id === roomId;
            });
            if (roomIdx > -1) {
                var newChats = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(state.rooms);
                newChats.splice(roomIdx, 1);
                // rearrange chat list
                state.rooms = newChats;
            }
            if (state.conversation[roomId]) {
                delete state.conversation[roomId];
            }
            if (state.lastMessage[roomId]) {
                delete state.lastMessage[roomId];
            }
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.readChat.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, roomId = _payload.roomId;
        if (error) {
            state.error = error;
        } else {
            var roomIdx = state.rooms.findIndex(function(room) {
                return room.id == roomId;
            });
            if (roomIdx > -1) {
                state.rooms[roomIdx].unread_count = 0;
                state.rooms[roomIdx].status.is_mentioned = false;
            }
            var requestIdx = state.requests.findIndex(function(room) {
                return room.id == roomId;
            });
            if (requestIdx > -1) {
                state.requests[requestIdx].unread_count = 0;
                state.requests[requestIdx].status.is_mentioned = false;
            }
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getRequestedRooms.pending, function(state, action) {
        state.error = null;
        var _arg = action.meta.arg, _offset = _arg.offset, offset = _offset === void 0 ? 0 : _offset, _hasLoading = _arg.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
        if (offset === 0) {
            if (hasLoading) {
                state.requests = [];
                state.isLoadingRooms = true;
            }
        } else {
            state.isLoadMoreRooms = true;
        }
    }).addCase(effects.getRequestedRooms.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message, offset = _payload.offset;
        if (error) {
            state.error = error;
        } else {
            var _requests;
            (_requests = state.requests).push.apply(_requests, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(data.rooms));
            state.error = null;
        }
        if (offset === 0) {
            state.isLoadingRooms = false;
        } else {
            state.isLoadMoreRooms = false;
        }
        state.message = message;
    }).addCase(effects.acceptRequestedRoom.pending, function(state) {
        state.error = null;
        state.isLoadAcceptRequest = true;
    }).addCase(effects.acceptRequestedRoom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
        }
        state.isLoadAcceptRequest = false;
        state.message = message;
    }).addCase(effects.rejectRequestedRoom.pending, function(state) {
        state.error = null;
        state.isLoadRejectRequest = true;
    }).addCase(effects.rejectRequestedRoom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error, roomId = _payload.roomId;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
            var roomIdx = state.requests.findIndex(function(room) {
                return room.id == roomId;
            });
            if (roomIdx > -1) {
                var newChats = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(state.requests);
                newChats.splice(roomIdx, 1);
                // rearrange chat list
                state.requests = newChats;
            }
            if (state.conversation[roomId]) {
                delete state.conversation[roomId];
            }
            if (state.lastMessage[roomId]) {
                delete state.lastMessage[roomId];
            }
        }
        state.isLoadRejectRequest = false;
        state.message = message;
    }).addCase(effects.forwardChat.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
        }
    })// handle block unblock from entities/user
    .addCase(lib_entities_user__WEBPACK_IMPORTED_MODULE_3__/* .effects.blockUser.fulfilled */ .Sz.blockUser.fulfilled, function(state, action) {
        var error = action.payload.error;
        var userId = action.meta.arg.userId;
        if (!error) {
            var roomIdx = state.rooms.findIndex(function(room) {
                var ref, ref1;
                return ((ref = room.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.personal) === null || ref1 === void 0 ? void 0 : ref1.user_id) === userId;
            });
            if (roomIdx > -1) {
                state.rooms[roomIdx].attributes.personal.is_blocked = true;
            }
        }
    }).addCase(lib_entities_user__WEBPACK_IMPORTED_MODULE_3__/* .effects.unblockUser.fulfilled */ .Sz.unblockUser.fulfilled, function(state, action) {
        var error = action.payload.error;
        var userId = action.meta.arg.userId;
        if (!error) {
            var roomIdx = state.rooms.findIndex(function(room) {
                var ref, ref1;
                return ((ref = room.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.personal) === null || ref1 === void 0 ? void 0 : ref1.user_id) === userId;
            });
            if (roomIdx > -1) {
                state.rooms[roomIdx].attributes.personal.is_blocked = false;
            }
        }
    }).addCase(effects.shareEventToChat.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.muteNotification.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message;
        var _arg = action.meta.arg, roomId = _arg.roomId, isMuted = _arg.isMuted;
        if (error) {
            state.error = error;
        } else {
            var roomIdx = state.rooms.findIndex(function(room) {
                return room.type === "ROOM_TYPE_GROUP" && room.id === parseInt(roomId, 10);
            });
            if (roomIdx >= 0) {
                state.rooms[roomIdx].status.is_muted = isMuted;
            }
            if (isMuted) {
                (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    content: "Notifications Muted",
                    messageType: "success",
                    alertType: "snackbar",
                    hasCloseIcon: true
                });
            } else {
                (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    content: "Notifications Unmuted",
                    messageType: "success",
                    alertType: "snackbar",
                    hasCloseIcon: true
                });
            }
        }
        state.message = message;
    }).addCase(effects.getSearchReceivers.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
            state.receivers.list = data.receivers;
        }
    }).addCase(effects.respondGroupInvitation.pending, function(state, action) {
        var _arg = action.meta.arg, respondAction = _arg.action;
        if (respondAction === "ACTION_REJECT") {
            state.invitation.isLoadingReject = true;
        } else {
            state.invitation.isLoadingAccept = true;
        }
    }).addCase(effects.respondGroupInvitation.fulfilled, function(state, action) {
        var error = action.payload.error;
        var _arg = action.meta.arg, respondAction = _arg.action, roomId = _arg.roomId;
        if (!error) {
            if (respondAction === "ACTION_REJECT") {
                var roomIdx = state.requests.findIndex(function(room) {
                    return room.id == roomId;
                });
                if (roomIdx > -1) {
                    state.requests.splice(roomIdx, 1);
                }
            }
        }
        state.invitation.isLoadingReject = false;
        state.invitation.isLoadingAccept = false;
    });
};
var chat = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSlice */ .oM)({
    name: "chat",
    reducers: reducers,
    extraReducers: extraReducers,
    initialState: initialState
});
/* harmony default export */ __webpack_exports__["ZP"] = (chat);


/***/ }),

/***/ 21671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ credentials; },
  "Sz": function() { return /* binding */ effects; },
  "dd": function() { return /* binding */ isLoggedInSelector; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: credentialSelector, initialState, userIdSelector

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/intercom.js

var schema = {
    app_id: "",
    user_hash: "",
    user_id: "",
    name: "",
    email: "",
    register_country: "",
    active_country: "",
    subs: "",
    created_at: 0,
    sms: 0,
    phone: 0,
    virtual_trading: false
};
var propTypes = {
    app_id: prop_types.string,
    user_hash: prop_types.string,
    user_id: prop_types.string,
    name: prop_types.string,
    email: prop_types.string,
    register_country: prop_types.string,
    active_country: prop_types.string,
    subs: prop_types.string,
    created_at: prop_types.number,
    sms: prop_types.number,
    phone: prop_types.number,
    virtual_trading: prop_types.bool
};
/* harmony default export */ var intercom = ({
    schema: schema,
    propTypes: propTypes
});

;// CONCATENATED MODULE: ./src/lib/models/auth/accessUser.js

var accessUser_schema = {
    username: "",
    email: "",
    fullname: "",
    avatar: "",
    password: 0,
    verified: 0,
    official: 0,
    privilege: 0,
    id: "",
    watchlist_id: 0,
    country: "",
    exchange: ""
};
var accessUser_propTypes = {
    username: prop_types.string,
    email: prop_types.string,
    fullname: prop_types.string,
    avatar: prop_types.string,
    password: prop_types.number,
    verified: prop_types.number,
    official: prop_types.number,
    privilege: prop_types.number,
    id: prop_types.string,
    watchlist_id: prop_types.number,
    country: prop_types.string,
    exchange: prop_types.string
};
/* harmony default export */ var accessUser = ({
    schema: accessUser_schema,
    propTypes: accessUser_propTypes
});

;// CONCATENATED MODULE: ./src/lib/models/auth/index.js



var auth_schema = {
    access_user: accessUser.schema,
    access_token: "",
    access_token_exp: 0,
    refresh_token: "",
    refresh_token_exp: 0,
    trading: 0,
    intercom: intercom.schema,
    onesignal_hash: "",
    support: {
        id: ""
    }
};
var auth_propTypes = {
    access_user: prop_types.object,
    access_token: prop_types.string,
    access_token_exp: prop_types.number,
    refresh_token: prop_types.string,
    refresh_token_exp: prop_types.number,
    trading: prop_types.string,
    intercom: intercom.schema,
    onesignal_hash: prop_types.string,
    support: {
        id: prop_types.string
    }
};
/* harmony default export */ var auth = ({
    schema: auth_schema,
    propTypes: auth_propTypes
});

// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var utils_auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/lib/api/authNext.ts + 1 modules
var authNext = __webpack_require__(39762);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
;// CONCATENATED MODULE: ./src/utils/authCookie.js



function getIsLoggedIn() {
    var ctx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var parsedCookie = (0,dist.parseCookies)(ctx);
    if (!parsedCookie || !parsedCookie.isLoggedIn) {
        return null;
    }
    return parsedCookie.isLoggedIn === "true";
}
function clearCookies() {
    return _clearCookies.apply(this, arguments);
}
function _clearCookies() {
    _clearCookies = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var parsedCookie, keys;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,dist.parseCookies)();
                case 2:
                    parsedCookie = _ctx.sent;
                    keys = Object.keys(parsedCookie);
                    keys = keys.filter(function(k) {
                        return k.includes("crisp") || k.includes("auth");
                    });
                    keys.forEach(function(k) {
                        return (0,dist.destroyCookie)(k);
                    });
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _clearCookies.apply(this, arguments);
}
/* harmony default export */ var authCookie = ({
    getIsLoggedIn: getIsLoggedIn,
    clearCookies: clearCookies
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/MainLayout/store.ts
var store = __webpack_require__(73580);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/login/constants.ts
var constants = __webpack_require__(16727);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/utils/socketSocialLocalStorage.ts
var socketSocialLocalStorage = __webpack_require__(42676);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/global/WebSocketV2/channels/roomList.ts
var roomList = __webpack_require__(34686);
// EXTERNAL MODULE: ./src/global/WebSocketV2/channels/chatRoom.ts
var chatRoom = __webpack_require__(42553);
// EXTERNAL MODULE: ./src/global/WebSocketV2/utils.ts
var utils = __webpack_require__(24050);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
;// CONCATENATED MODULE: ./src/lib/entities/credentials.js







// Auth

















/**
 * getAccessToken
 * to is valid current token in cookies
 * @param {} null
 * @returns boolean
 */ var isValidAccessToken = function() {
    var parsedCookie = authData.getToken(null);
    if (parsedCookie) {
        var token = parsedCookie.accessToken.token;
        return !!token;
    }
    return false;
};
/**
 * disconnectWebSocketSocial
 * @param {Array} subscribedRoomsId
 */ var disconnectWebSocketSocial = function(dispatch, subscribedRoomsId) {
    (0,utils/* wsLogger */.IT)({
        module: constant/* DATA_WS_LOGGER.MODULE_NAME */.$6.MODULE_NAME,
        action: constant/* DATA_WS_LOGGER.ACTION.DISCONNECT */.$6.ACTION.DISCONNECT
    });
    // reset state active room id
    dispatch(slice/* effects.resetActiveRoomId */.Sz.resetActiveRoomId());
    // unsubscribe ws social: chatrooms
    dispatch((0,chatRoom/* unSubscribeToChatRooms */.q)(subscribedRoomsId));
    // unsubscribe ws social: roomList
    dispatch((0,roomList/* unSubscribeToRoomList */.M)());
    // clear inverval ping WS Social
    (0,WebSocketV2_slice/* clearIntervalPingWSSocial */.Z)();
    // allowed reconnection ws social
    (0,socketSocialLocalStorage/* storeErrorNoReconnectionWsSocial */.x1)(constant/* WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION.ALLOWED */.z.ALLOWED);
    (0,socketSocialLocalStorage/* removeFeatureFlagDebugWsSocial */.QK)();
};
// initial state
var initialState = {
    data: auth.schema,
    // check token from cookies
    isLoggedIn: (0,app/* isClient */.C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at),
    error: null,
    message: ""
};
// Selectors -------------------------------------------------------------------
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.credentials;
}, function(state) {
    return {
        data: state.data,
        isLoggedIn: state.isLoggedIn,
        isLoading: state.isLoading,
        error: state.error,
        message: state.message
    };
});
var userIdSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.credentials.data;
}, function(credentials) {
    var ref;
    return credentials === null || credentials === void 0 ? void 0 : (ref = credentials.access_user) === null || ref === void 0 ? void 0 : ref.id;
});
var isLoggedInSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.credentials.isLoggedIn;
}, function(isLoggedIn) {
    return isLoggedIn;
});
var credentialSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.credentials.data;
}, function(data) {
    return data;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@entities/credentials";
var actionType = {
    LOGOUT: "".concat(CONTEXT, "/logout"),
    REFRESH: "".concat(CONTEXT, "/refresh")
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    loadCredentialsExodus: function(state, action) {
        var _payload = action.payload, user = _payload.user, access = _payload.access, refresh = _payload.refresh, onesignal_hash = _payload.onesignal_hash, support = _payload.support;
        var accessUser = {
            username: user.username,
            email: user.email,
            fullname: user.fullname,
            avatar: user.avatar,
            password: Number(user.has_password_been_set),
            verified: Number(user.is_verified),
            privilege: user.privilege.code,
            id: user.id,
            watchlist_id: user.watchlist_id,
            country: user.country,
            exchange: user.exchange
        };
        var parsedToken = {
            access: {
                token: access.token,
                expired_at: new Date(access.expired_at).getTime()
            },
            refresh: {
                token: refresh.token,
                expired_at: new Date(refresh.expired_at).getTime()
            }
        };
        utils_auth/* default.saveToken */.Z.saveToken({
            accessToken: parsedToken.access.token,
            accessTokenExp: parsedToken.access.expired_at,
            refreshToken: parsedToken.refresh.token,
            refreshTokenExp: parsedToken.refresh.expired_at,
            accessUser: accessUser
        });
        var data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            access_token: parsedToken.access.token,
            access_token_exp: parsedToken.access.expired_at,
            refresh_token: parsedToken.refresh.token,
            refresh_token_exp: parsedToken.refresh.expired_at,
            access_user: accessUser,
            onesignal_hash: onesignal_hash,
            support: {
                id: support ? support.id : ""
            }
        });
        state.data = data;
        state.isLoggedIn = true;
    },
    loadCredentialsToken: function(state, action) {
        var _payload = action.payload, access = _payload.access, refresh = _payload.refresh;
        var parsedAccessExpired = new Date(access.expired_at).getTime() / 1000;
        var parsedRefreshExpired = new Date(refresh.expired_at).getTime() / 1000;
        auth.saveToken({
            accessToken: access.token,
            accessTokenExp: parsedAccessExpired,
            refreshToken: refresh.token,
            refreshTokenExp: parsedRefreshExpired
        });
    }
};
// effects
var effects = {
    // logout --------------------------------------------------------------------
    logout: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.LOGOUT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_, param) {
            var dispatch, getState, response, ref, ref1, ref2, subscribedRoomsId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch = param.dispatch, getState = param.getState;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,authNext/* logout */.kS)();
                    case 4:
                        response = _ctx.sent;
                        if (!response.data.loggedOut) {
                            _ctx.next = 18;
                            break;
                        }
                        ;
                        localStorage.setItem(constants/* IS_LOGGED_IN_LOCALSTORAGE */.J4, false);
                        subscribedRoomsId = (ref = getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.entities) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chat) === null || ref2 === void 0 ? void 0 : ref2.activeRoomId;
                        // unsubscribe & disconnect ws social
                        disconnectWebSocketSocial(dispatch, subscribedRoomsId);
                        _ctx.next = 12;
                        return authCookie.clearCookies();
                    case 12:
                        store/* default.setState */.Z.setState({
                            errorCode: null
                        });
                        (0,crisp/* destroyCurrentSession */.te)();
                        utils_auth/* default.destroyToken */.Z.destroyToken();
                        _ctx.next = 17;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 17:
                        return _ctx.abrupt("return", {
                            message: "Logout success"
                        });
                    case 18:
                        return _ctx.abrupt("return", response.data);
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            message: "Logout attempt failed!"
                        });
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    21
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var extraReducers = (_obj = {}, (0,_define_property/* default */.Z)(_obj, es6/* HYDRATE */.ju, function(draft, action) {
    draft.data = action.payload.auth.credentials.data;
    draft.isLoggedIn = action.payload.auth.credentials.isLoggedIn || (0,app/* isClient */.C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
    draft.isLoading = action.payload.auth.credentials.isLoading;
    draft.error = action.payload.auth.credentials.error;
    draft.message = action.payload.auth.credentials.message;
}), // logout reducer ------------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.logout.fulfilled, function(draft, action) {
    var message = action.payload.message;
    draft.isLoggedIn = false;
    draft.message = message;
    draft.data = null;
    draft.isLoading = false;
    draft.error = null;
    router_default().push("/login");
}), _obj);
// Slice -----------------------------------------------------------------------
var credentialsSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "credentials",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var credentials = (credentialsSlice);


/***/ }),

/***/ 56214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony export selectors */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1955);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6430);






// APIs


// Initial state
var initialState = {
    toggleTopUser: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    toggleBlockUser: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    suspendUser: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(function(state) {
    return state.entities.moderation;
}, function(moderation) {
    return {
        toggleTopUser: moderation.toggleTopUser,
        toggleBlockUser: moderation.toggleBlockUser
    };
});
// Action types
var CONTEXT = "@redux/moderation";
var actionType = {
    BLOCK_USER: "".concat(CONTEXT, "/BLOCK_USER"),
    UNBLOCK_USER: "".concat(CONTEXT, "/UNBLOCK_USER"),
    SUSPEND_USER: "".concat(CONTEXT, "/SUSPEND_USER")
};
// effects
var effects = {
    // Block unblock user
    blockUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.BLOCK_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userId) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].blockUser */ .Z.blockUser(userId);
                    case 3:
                        response = _ctx.sent;
                        if (response) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to block user failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content: message,
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(userId) {
            return _ref.apply(this, arguments);
        };
    }()),
    unblockUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.UNBLOCK_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userId) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unblockUser */ .Z.unblockUser(userId);
                    case 3:
                        response = _ctx.sent;
                        if (response) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to block user failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(userId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // suspend user
    suspendUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.SUSPEND_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(suspendData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].suspendUser */ .Z.suspendUser(suspendData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to suspend user failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content: message,
                            alertType: "plain",
                            messageType: "success"
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(suspendData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var _obj;
var extraReducers = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.blockUser.pending, function(state) {
    state.toggleBlockUser.isLoading = true;
    state.toggleBlockUser.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.blockUser.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
    if (error) {
        state.toggleBlockUser.error = error;
    } else {
        state.toggleBlockUser.data = data;
    }
    state.toggleBlockUser.message = message;
    state.toggleBlockUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.blockUser.rejected, function(state, action) {
    state.toggleBlockUser.error = action.payload.error;
    state.toggleBlockUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.unblockUser.pending, function(state) {
    state.toggleBlockUser.isLoading = true;
    state.toggleBlockUser.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.unblockUser.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
    if (error) {
        state.toggleBlockUser.error = error;
    } else {
        state.toggleBlockUser.data = data;
    }
    state.toggleBlockUser.message = message;
    state.toggleBlockUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.unblockUser.rejected, function(state, action) {
    state.toggleBlockUser.error = action.payload.error;
    state.toggleBlockUser.isLoading = false;
}), // Suspend user
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.suspendUser.pending, function(state) {
    state.suspendUser.isLoading = true;
    state.suspendUser.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.suspendUser.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
    if (error) {
        state.suspendUser.error = error;
    } else {
        state.suspendUser.data = data;
    }
    state.suspendUser.message = message;
    state.suspendUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, effects.suspendUser.rejected, function(state, action) {
    state.suspendUser.error = action.payload.error;
    state.suspendUser.isLoading = false;
}), _obj);
var moderation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "moderation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (moderation);


/***/ }),

/***/ 16992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61876);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6430);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44590);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1955);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15056);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25516);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41208);
/* harmony import */ var features_chat_analytics_GeneralEventAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72804);
/* harmony import */ var features_chat_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33037);
/* harmony import */ var _watchlist__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14675);
/* harmony import */ var _moderation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56214);
/* eslint-disable camelcase */ 






// APIs









var STATUS_FOLLOWING = {
    FOLLOW: true,
    UNFOLLOW: false
};
var COUNT_FOLLOWING = {
    FOLLOW: 1,
    UNFOLLOW: -1
};
var initialState = {
    selected: {},
    detail: {},
    list: [],
    isLoading: false,
    error: null,
    message: "",
    search: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    toggleFollowUser: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    toggleAlertUser: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    searchContact: {
        data: [],
        isLoading: false,
        isLoadingMore: false,
        error: null,
        message: "",
        hasMore: false
    },
    toggleBlockUser: {
        isLoading: false
    }
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(function(state) {
    return state.entities.user;
}, function(user) {
    return {
        detail: user.detail,
        list: user.list,
        search: user.search,
        isLoading: user.isLoading,
        error: user.error,
        message: user.message,
        toggleFollowUser: user.toggleFollowUser,
        searchContact: user.searchContact,
        toggleBlockUser: user.toggleBlockUser
    };
});
var CONTEXT = "@redux/user";
var actionType = {
    SEARCH_USER: "".concat(CONTEXT, "/SEARCH_USER"),
    GET_PROFILE: "".concat(CONTEXT, "/GET_PROFILE"),
    GET_PROFILE_CURRENT: "".concat(CONTEXT, "/GET_PROFILE_CURRENT"),
    GET_PROFILE_EXODUS: "".concat(CONTEXT, "/GET_PROFILE_EXODUS"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    UNFOLLOW_USER: "".concat(CONTEXT, "/UNFOLLOW_USER"),
    SET_ALERT_USER: "".concat(CONTEXT, "/SET_ALERT_USER"),
    SEARCH_USER_CONTACT: "".concat(CONTEXT, "/SEARCH_USER_CONTACT"),
    RESET_SEARCH_USER_CONTACT: "".concat(CONTEXT, "/RESET_SEARCH_USER_CONTACT"),
    BLOCK_USER: "".concat(CONTEXT, "/BLOCK_USER"),
    UNBLOCK_USER: "".concat(CONTEXT, "/UNBLOCK_USER")
};
// Effects -----------------------------------------------------------------
var effects = {
    searchUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.SEARCH_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(keyword) {
            var response, _data, _$error, data, message, peopleData;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getSearchPeople */ .Z.getSearchPeople(keyword);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to search user failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        peopleData = data.people;
                        return _ctx.abrupt("return", {
                            data: peopleData,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getUserProfile: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.GET_PROFILE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(username, thunkAPI) {
            var response, _data, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (username) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Username is required!");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserProfileGraph */ .Z.getUserProfileGraph(username);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get user profile failed");
                    case 8:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            username: username
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", thunkAPI.rejectWithValue({
                            error: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        }));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(username, thunkAPI) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCurrentUserProfile: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.GET_PROFILE_CURRENT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(username, thunkAPI) {
            var response, _data, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (username) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Username is required!");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCurrentUserProfileGraph */ .Z.getCurrentUserProfileGraph();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get user profile failed");
                    case 8:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            username: username
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", thunkAPI.rejectWithValue({
                            error: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        }));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(username, thunkAPI) {
            return _ref.apply(this, arguments);
        };
    }()),
    setNotificationAlertUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.SET_ALERT_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var userid, username, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, username = param.username;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_4__/* ["default"].setNotificationAlert */ .Z.setNotificationAlert(userid);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to set notification alert failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            username: username
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    searchUserContact: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.SEARCH_USER_CONTACT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _keyword, keyword, _page, page, ref, response, _data, _$error, data, message, peopleData;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _keyword = param.keyword, keyword = _keyword === void 0 ? "" : _keyword, _page = param.page, page = _page === void 0 ? 1 : _page;
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getSearchPeople */ .Z.getSearchPeople(keyword, page);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to search user failed");
                    case 8:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        peopleData = data.people;
                        // tracker new message user filled
                        (0,features_chat_utils__WEBPACK_IMPORTED_MODULE_8__/* .chatAnalytics */ .rP)(function() {
                            return features_chat_analytics_GeneralEventAnalytics__WEBPACK_IMPORTED_MODULE_7__/* ["default"].onChatSearchUserFilled */ .ZP.onChatSearchUserFilled();
                        }, function() {
                            return undefined;
                        });
                        return _ctx.abrupt("return", {
                            data: peopleData,
                            message: message,
                            page: page,
                            hasMore: (data === null || data === void 0 ? void 0 : (ref = data.pagination) === null || ref === void 0 ? void 0 : ref.has_more_users) || false
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    resetSearchUserContact: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.RESET_SEARCH_USER_CONTACT, function() {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, initialState.searchContact);
    }),
    blockUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.BLOCK_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var userId, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        userId = params.userId;
                        _ctx.next = 4;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].blockUser */ .Z.blockUser(userId);
                    case 4:
                        response = _ctx.sent;
                        if (response) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to block user failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    unblockUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)(actionType.UNBLOCK_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var userId, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        userId = params.userId;
                        _ctx.next = 4;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unblockUser */ .Z.unblockUser(userId);
                    case 4:
                        response = _ctx.sent;
                        if (response) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to block user failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers -----------------------------------------------------------------
var reducers = {};
var _obj;
// Extra reducers -----------------------------------------------------------
var extraReducers = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.searchUser.pending, function(state) {
    state.search.isLoading = true;
    state.search.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.searchUser.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
    if (error) {
        state.search.error = error;
    } else {
        state.search.data = data;
        state.search.error = null;
    }
    state.search.isLoading = false;
    state.search.message = message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.searchUser.rejected, function(state, action) {
    state.search.error = action.payload.error;
    state.search.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.getUserProfile.pending, function(state) {
    state.isLoading = true;
    state.error = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.getUserProfile.rejected, function(state, action) {
    var error = action.payload.error;
    state.isLoading = false;
    state.error = error;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.getUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, message = _payload.message, data = _payload.data, username = _payload.username;
    state.detail[username] = data;
    state.error = null;
    state.isLoading = false;
    state.message = message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.getCurrentUserProfile.pending, function(state) {
    state.isLoading = true;
    state.error = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.getCurrentUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, message = _payload.message, data = _payload.data, username = _payload.username;
    state.detail[username] = data;
    state.error = null;
    state.isLoading = false;
    state.message = message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.getCurrentUserProfile.rejected, function(state, action) {
    var error = action.payload.error;
    state.isLoading = false;
    state.error = error;
}), // Follow unfollow user from watchlist
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, _watchlist__WEBPACK_IMPORTED_MODULE_9__/* .effects.followUser.pending */ .Sz.followUser.pending, function(state) {
    state.toggleFollowUser.isLoading = true;
    state.toggleFollowUser.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, _watchlist__WEBPACK_IMPORTED_MODULE_9__/* .effects.followUser.fulfilled */ .Sz.followUser.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, username = _payload.username, type = _payload.type;
    if (error) {
        state.toggleFollowUser.error = error;
    } else {
        var ref, ref1, ref2;
        state.toggleFollowUser.data = data;
        if (((ref = state.detail[username]) === null || ref === void 0 ? void 0 : ref.followed) !== undefined) {
            state.detail[username].followed = STATUS_FOLLOWING[type];
            state.detail[username].additional.followers = parseInt(state.detail[username].additional.followers, 10) + COUNT_FOLLOWING[type];
            state.detail[username].is_alert_enabled = STATUS_FOLLOWING[type];
        } else if (((ref1 = state.detail[username]) === null || ref1 === void 0 ? void 0 : ref1.is_followed) !== undefined) {
            state.detail[username].is_followed = STATUS_FOLLOWING[type];
            state.detail[username].statistics.follower_count = parseInt(state.detail[username].statistics.follower_count, 10) + COUNT_FOLLOWING[type];
            state.detail[username].is_alert_enabled = STATUS_FOLLOWING[type];
        } else if (((ref2 = state.detail[username]) === null || ref2 === void 0 ? void 0 : ref2.status.is_followed) !== undefined) {
            state.detail[username].status.is_followed = STATUS_FOLLOWING[type];
            state.detail[username].status.is_post_alert_enabled = STATUS_FOLLOWING[type];
            state.detail[username].statistic.follower_count += COUNT_FOLLOWING[type];
        }
    }
    state.toggleFollowUser.message = message;
    state.toggleFollowUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, _watchlist__WEBPACK_IMPORTED_MODULE_9__/* .effects.followUser.rejected */ .Sz.followUser.rejected, function(state, action) {
    state.toggleFollowUser.error = action.payload.error;
    state.toggleFollowUser.isLoading = false;
}), // Block from moderation effect
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, _moderation__WEBPACK_IMPORTED_MODULE_10__/* .effects.blockUser.fulfilled */ .Sz.blockUser.fulfilled, function(state, action) {
    var error = action.payload.error;
    var userId = action.meta.arg;
    if (!error) {
        var user = Object.values(state.detail).find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.user_id) === userId;
        });
        if (user) {
            state.detail[user.profile.username].status.is_blocked = true;
        }
    }
}), // Unblock from moderation effect
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, _moderation__WEBPACK_IMPORTED_MODULE_10__/* .effects.unblockUser.fulfilled */ .Sz.unblockUser.fulfilled, function(state, action) {
    var error = action.payload.error;
    var userId = action.meta.arg;
    if (!error) {
        var user = Object.values(state.detail).find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.user_id) === userId;
        });
        if (user) {
            state.detail[user.profile.username].status.is_blocked = false;
        }
    }
}), // Set nofitication alert
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.setNotificationAlertUser.pending, function(state) {
    state.toggleAlertUser.isLoading = true;
    state.toggleAlertUser.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.setNotificationAlertUser.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, username = _payload.username;
    if (error) {
        state.toggleAlertUser.error = error;
    } else {
        var successMessage = message;
        if ((data === null || data === void 0 ? void 0 : data.alert) === false) {
            successMessage = "You have unsubscribed from user @".concat(username);
        }
        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            content: successMessage,
            alertType: "plain",
            messageType: "success",
            hasCloseIcon: false
        });
        state.toggleAlertUser.data = data;
        state.detail[username].status.is_post_alert_enabled = data.alert;
    }
    state.toggleAlertUser.message = message;
    state.toggleAlertUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.setNotificationAlertUser.rejected, function(state, action) {
    state.toggleAlertUser.error = action.payload.error;
    state.toggleAlertUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.searchUserContact.pending, function(state, action) {
    var page = action.meta.arg.page;
    if (page === 1) {
        state.searchContact.isLoading = true;
    } else {
        state.searchContact.isLoadingMore = true;
    }
    state.searchContact.error = null;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.searchUserContact.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, page = _payload.page, hasMore = _payload.hasMore;
    if (error) {
        state.searchContact.error = error;
    } else {
        state.searchContact.hasMore = hasMore;
        if (page === 1) {
            state.searchContact.data = data;
            state.searchContact.isLoading = false;
        } else {
            var _data;
            (_data = state.searchContact.data).push.apply(_data, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(data));
            state.searchContact.isLoadingMore = false;
        }
        state.searchContact.error = null;
    }
    state.searchContact.isLoading = false;
    state.searchContact.message = message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.searchUserContact.rejected, function(state, action) {
    state.searchContact.error = action.payload.error;
    state.searchContact.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.resetSearchUserContact.fulfilled, function(state, action) {
    var _payload = action.payload, message = _payload.message, data = _payload.data, hasMore = _payload.hasMore;
    state.searchContact.data = data;
    state.searchContact.isLoading = false;
    state.searchContact.hasMore = hasMore;
    state.searchContact.message = message;
}), // Block un block user
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.blockUser.pending, function(state) {
    state.toggleBlockUser.isLoading = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.blockUser.fulfilled, function(state, action) {
    var error = action.payload.error;
    var username = action.meta.arg.username;
    if (!error && state.detail[username] && username) {
        state.detail[username].is_blocked = true;
    }
    state.toggleBlockUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.blockUser.rejected, function(state) {
    state.toggleBlockUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.unblockUser.pending, function(state) {
    state.toggleBlockUser.isLoading = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.unblockUser.fulfilled, function(state, action) {
    var error = action.payload.error;
    var username = action.meta.arg.username;
    if (!error && state.detail[username] && username) {
        state.detail[username].is_blocked = false;
    }
    state.toggleBlockUser.isLoading = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, effects.unblockUser.rejected, function(state) {
    state.toggleBlockUser.isLoading = false;
}), _obj);
var user = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createSlice */ .oM)({
    name: "user",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (user);


/***/ }),

/***/ 14675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* eslint-disable no-undef */ 




// APIs

// Related stores
// import { effects as userEffects } from './user';
// Initial State
// This watchlist will be stored per user id
var initialState = {
    people: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    symbol: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    isLoading: false,
    message: "",
    error: null
};
// selector
var watchlistSelector = function(state) {
    return state.entities.watchlist;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(watchlistSelector, function(watchlist) {
    return {
        people: watchlist.people,
        symbol: watchlist.symbol
    };
});
// Action types
var CONTEXT = "@redux/watchlist";
var actionType = {
    ADD_COMPANY_WATCHLIST: "".concat(CONTEXT, "/ADD_COMPANY_WATCHLIST"),
    GET_PEOPLE_WATCHLIST: "".concat(CONTEXT, "/GET_PEOPLE_WATCHLIST"),
    GET_SYMBOL_WATCHLIST: "".concat(CONTEXT, "/GET_SYMBOL_WATCHLIST"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    FOLLOW_COMPANY: "".concat(CONTEXT, "/FOLLOW_COMPANY")
};
// Side effects
var effects = {
    addCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.ADD_COMPANY_WATCHLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, description, companyId, response, _data, data, error, error_type, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, description = param.description, companyId = param.companyId;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].createNewWatchlist */ .Z.createNewWatchlist(name, description);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to add company watchlist failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                        if (!(error || error_type)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error || error_type);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            companyId: companyId
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SYMBOL_WATCHLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(companyId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAllWatchlist */ .Z.getAllWatchlist(companyId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get user company watchlist failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            companyId: companyId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(companyId) {
            return _ref.apply(this, arguments);
        };
    }()),
    followUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.FOLLOW_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var username, userid, _type, type, targetAPI, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = param.username, userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User id is empty");
                    case 4:
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postFollowUser */ .Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowUser */ .Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Attempt to follow user failed");
                    case 11:
                        _data = response.data, _$error = _data.error_type, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 14:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            type: type,
                            username: username,
                            userid: userid
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    followCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.FOLLOW_COMPANY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistId, companyId, _type, type, targetAPI, response, _data, error_type, error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        if (!(!companyId && !watchlistId)) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Missing parameters wathclist id or company id");
                    case 3:
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postFollowCompany */ .Z.postFollowCompany;
                        if (type === "UNFOLLOW") {
                            // @ts-ignore
                            targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowCompany */ .Z.postUnfollowCompany;
                        }
                        _ctx.next = 7;
                        return targetAPI(watchlistId, companyId);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to follow company failed");
                    case 10:
                        _data = response.data, error_type = _data.error_type, error = _data.error, message = _data.message, data = _data.data;
                        if (!(error || error_type)) {
                            _ctx.next = 13;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: error,
                            message: message
                        });
                    case 13:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            error: error,
                            watchlistId: watchlistId,
                            companyId: companyId,
                            type: type
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.getCompanyWatchlist.pending, function(state) {
        state.symbol.isLoading = true;
        state.symbol.error = null;
    }).addCase(effects.getCompanyWatchlist.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, companyId = _payload.companyId;
        if (error) {
            state.symbol.error = error;
        } else {
            state.symbol.data[companyId] = data;
            state.error = null;
        }
        state.symbol.isLoading = false;
        state.symbol.message = message;
    }).addCase(effects.getCompanyWatchlist.rejected, function(state, action) {
        state.symbol.error = action.payload.error;
        state.symbol.isLoading = false;
    }).addCase(effects.followUser.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, username = _payload.username, type = _payload.type;
        if (!error) {
            if (state.people.data[username]) {
                state.people.data[username][0].followed = type === "FOLLOW" ? 1 : 0;
            }
        }
    })// Create company watchlist
    .addCase(effects.addCompanyWatchlist.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message, companyId = _payload.companyId;
        if (!error) {
            if (!!companyId) {
                state.symbol.data[companyId].push(data);
            }
        }
        state.symbol.message = message;
    }).addCase(effects.addCompanyWatchlist.rejected, function(state, action) {
    // Do something when error occurred
    }).addCase(effects.followCompany.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, watchlistId = _payload.watchlistId, companyId = _payload.companyId, type = _payload.type;
        if (!error) {
            var activeSymbol = state.symbol.data[companyId];
            if (activeSymbol) {
                var idx = activeSymbol.findIndex(function(item) {
                    return item.watchlist_id === watchlistId;
                });
                if (idx !== -1) {
                    var FOLLOWING = type === "FOLLOW" ? 1 : 0;
                    if (!FOLLOWING) {
                        // Unfollow company
                        // If unfollow all watchlist, unfollow from all child
                        if (idx === 0) {
                            var newData = state.symbol.data[companyId].map(function(item) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, item), {
                                    followed: FOLLOWING
                                });
                            });
                            state.symbol.data[companyId] = newData;
                        }
                    } else {
                        // If first time following, auto set following to all watchlist
                        // Set all watchlist to following
                        state.symbol.data[companyId][0].followed = FOLLOWING;
                    }
                    // If follow specific child, also add following to all watchlist
                    // Update the selected wathclist item
                    state.symbol.data[companyId][idx].followed = FOLLOWING;
                }
            }
        }
    });
};
var watchlist = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "watchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (watchlist);


/***/ }),

/***/ 21779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ parseFileExtension; },
/* harmony export */   "j": function() { return /* binding */ uniq; }
/* harmony export */ });
/**
 * Parse File Extension
 * @param {string} url - URL Of File
 * @returns {string} extension of file url
 */ var parseFileExtension = function(url) {
    var extension = url === null || url === void 0 ? void 0 : url.match(/\.[0-9a-z]+$/i);
    if (extension) {
        return extension[0];
    }
    return "";
};
function uniq(a, key) {
    var seen = new Set();
    return a.filter(function(item) {
        var k = key(item);
        return seen.has(k) ? false : seen.add(k);
    });
}



/***/ }),

/***/ 42676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QK": function() { return /* binding */ removeFeatureFlagDebugWsSocial; },
/* harmony export */   "QW": function() { return /* binding */ saveIdIntervalPingWsSocial; },
/* harmony export */   "r8": function() { return /* binding */ getIdIntervalPingWsSocial; },
/* harmony export */   "rv": function() { return /* binding */ removeIdIntervalPingWsSocial; },
/* harmony export */   "vW": function() { return /* binding */ getErrorNoReconnectionWsSocial; },
/* harmony export */   "x1": function() { return /* binding */ storeErrorNoReconnectionWsSocial; }
/* harmony export */ });
/* unused harmony exports getFeatureFlagDebugWsSocial, storeFeatureFlagDebugWsSocial */
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);


var saveIdIntervalPingWsSocial = function(idInterval) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.setItem(features_chat_constant__WEBPACK_IMPORTED_MODULE_1__/* .WEBSOCKET_WS_SOCIAL_PING_INTERNAL */ .ts, idInterval);
    }
};
var getIdIntervalPingWsSocial = function() {
    return localStorage.getItem(features_chat_constant__WEBPACK_IMPORTED_MODULE_1__/* .WEBSOCKET_WS_SOCIAL_PING_INTERNAL */ .ts);
};
var removeIdIntervalPingWsSocial = function() {
    localStorage.removeItem(features_chat_constant__WEBPACK_IMPORTED_MODULE_1__/* .WEBSOCKET_WS_SOCIAL_PING_INTERNAL */ .ts);
};
var storeErrorNoReconnectionWsSocial = function(value) {
    localStorage.setItem(features_chat_constant__WEBPACK_IMPORTED_MODULE_1__/* .WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION.NAME */ .z.NAME, value);
};
var getErrorNoReconnectionWsSocial = function() {
    return localStorage.getItem(features_chat_constant__WEBPACK_IMPORTED_MODULE_1__/* .WEBSOCKET_WS_SOCIAL_ERROR_NO_RECONNECTION.NAME */ .z.NAME);
};
var getFeatureFlagDebugWsSocial = function() {
    return localStorage.getItem(DEBUG_WS_SOCIAL) || "false";
};
var storeFeatureFlagDebugWsSocial = function(isAllowed) {
    localStorage.setItem(DEBUG_WS_SOCIAL, isAllowed);
};
var removeFeatureFlagDebugWsSocial = function() {
    localStorage.removeItem(features_chat_constant__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_WS_SOCIAL */ .of);
};



/***/ })

}]);